import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { Bar, Doughnut, Line } from "recharts";
import {
  BarChart,
  LineChart,
  PieChart,
  Pie,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Tooltip as RechartTooltip
} from "recharts";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { DashcalpostData } from "../../store/reducers/Formapireducer";
import { Employeeautocomplete } from "../../ui-components/global/Autocomplete";
import Datavisual1 from "./Calendar";
import { Avatar, Box, Chip, Dialog, DialogContent, DialogTitle, Divider, Grid, IconButton, Paper, Skeleton, Typography } from "@mui/material";
import EmployeeDashboard from "./EmployeeDashboard";
import { dashBoard_V2, dashBoardAtten } from "../../store/reducers/LoginReducer";
import Chart from "react-apexcharts";
import LeaveApprovalModal from "../Modals/LeaveApprovalModal";
import CloseIcon from "@mui/icons-material/Close";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import AssignmentIcon from "@mui/icons-material/Assignment";
/* ─────────────────────────── HELPERS ─────────────────────── */
const badgeStyle = { r: "#FEE2E2:#991B1B", y: "#FEF3C7:#92400E", g: "#D1FAE5:#065F46", b: "#DBEAFE:#1D4ED8" };
function Badge({ bc, children }) {
  const [bg, color] = (badgeStyle[bc] || "").split(":");
  return <span style={{ fontSize: 9, fontWeight: 700, padding: "2px 8px", borderRadius: 10, background: bg, color }}>{children}</span>;
}

const CUSTOM_TOOLTIP = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div style={{ background: "#1E2A3B", border: "1px solid rgba(255,255,255,.1)", borderRadius: 8, padding: "8px 12px", fontSize: 11 }}>
      <div style={{ color: "#9CA3AF", marginBottom: 4, fontWeight: 700 }}>{label}</div>
      {payload.map(p => (
        <div key={p.dataKey} style={{ color: "#fff", display: "flex", gap: 8, alignItems: "center" }}>
          <span style={{ width: 8, height: 8, borderRadius: 2, background: p.fill || p.color, display: "inline-block" }} />
          <span style={{ color: "#9CA3AF" }}>{p.dataKey}:</span>
          <span style={{ fontFamily: "'Outfit',sans-serif", fontWeight: 700 }}>{p.value}</span>
        </div>
      ))}
    </div>
  );
};
const CUSTOM_TOOLTIP_KPI1 = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;

  return (
    <div style={{
      background: "#1E2A3B",
      border: "1px solid rgba(255,255,255,.1)",
      borderRadius: 8,
      padding: "8px 12px",
      fontSize: 11
    }}>
      <div style={{ color: "#9CA3AF", marginBottom: 4, fontWeight: 700 }}>
        {label}
      </div>

      {payload.map(p => (
        <div key={p.dataKey} style={{
          color: "#fff",
          display: "flex",
          gap: 8,
          alignItems: "center"
        }}>
          <span style={{
            width: 8,
            height: 8,
            borderRadius: 2,
            background: p.fill || p.color,
            display: "inline-block"
          }} />

          <span style={{ color: "#9CA3AF" }}>
            {p.name}:
          </span>

          <span style={{ fontFamily: "'Outfit',sans-serif", fontWeight: 700 }}>
            {p.value}
          </span>
        </div>
      ))}
    </div>
  );
};


/* ─────────────────────────── KPI CARD ─────────────────────── */
function KpiCard({ card, onClick }) {
  const extra = card.members?.find(m => m.id.startsWith("+"));
  const totalMembers =
    (card.members?.filter(m => !m.id.startsWith("+")).length || 0) +
    (extra ? Number(extra.id.replace("+", "")) : 0);
  return (
    <div onClick={() => onClick(card)} style={{ background: card.gradient, borderRadius: 20, padding: "22px 22px 20px", position: "relative", overflow: "hidden", cursor: "pointer", minHeight: 190, display: "flex", flexDirection: "column", transition: "transform .15s, box-shadow .15s" }}
      onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-4px)"; e.currentTarget.style.boxShadow = "0 12px 40px rgba(0,0,0,.25)"; }}
      onMouseLeave={e => { e.currentTarget.style.transform = ""; e.currentTarget.style.boxShadow = ""; }}>
      {/* Blobs */}
      <div style={{ position: "absolute", right: -22, top: -22, width: 88, height: 88, borderRadius: "50%", background: "rgba(255,255,255,.1)", pointerEvents: "none" }} />
      <div style={{ position: "absolute", right: 12, top: 12, width: 48, height: 48, borderRadius: "50%", background: "rgba(255,255,255,.08)", pointerEvents: "none" }} />
      {/* Icon */}
      <div style={{ position: "absolute", right: 18, top: 18, width: 44, height: 44, borderRadius: 14, background: "rgba(255,255,255,.2)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1 }}>
        <svg viewBox="0 0 20 20" fill="#fff" width={22} height={22}>{card.icon}</svg>
      </div>
      {/* Label */}
      <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 6 }}>
        <svg viewBox="0 0 20 20" fill="rgba(255,255,255,.8)" width={11} height={11}>{card.icon}</svg>
        <span style={{ fontSize: 12, fontWeight: 800, color: "rgba(255,255,255,.8)", letterSpacing: ".08em" }}>{card.label}</span>
      </div>
      {/* Value + change */}
      <div style={{ display: "flex", alignItems: "flex-end", gap: 10, marginBottom: 4 }}>
        <div style={{ fontSize: 52, fontWeight: 800, color: "#fff", fontFamily: "'Outfit',sans-serif", lineHeight: 1 }}>{card.value}</div>
        <div style={{ fontSize: 10, fontWeight: 700, background: "rgba(255,255,255,.22)", color: "#fff", padding: "3px 9px", borderRadius: 20, marginBottom: 6, alignSelf: "flex-end" }}>{card.chg}</div>
      </div>
      {/* Spark or Progress */}
      {card.type === "spark" && (
        <div style={{ display: "flex", alignItems: "flex-end", gap: 4, height: 32, margin: "10px 0 12px" }}>
          {card.sparkHeights.map((h, i) => (
            <div key={i} style={{ flex: 1, height: `${h}%`, borderRadius: "4px 4px 0 0", background: "rgba(255,255,255,.28)" }} />
          ))}
        </div>
      )}
      {card.type === "progress" && (
        <div style={{ margin: "4px 0 12px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", fontSize: 10, fontWeight: 700, color: "rgba(255,255,255,.75)", marginBottom: 5 }}>
            <span>{card.progLbl}</span><span>{card.progVal}</span>
          </div>
          <div style={{ height: 6, background: "rgba(255,255,255,.2)", borderRadius: 3, overflow: "hidden" }}>
            <div style={{ height: "100%", width: `${card.progPct}%`, borderRadius: 3, background: "rgba(255,255,255,.75)" }} />
          </div>
        </div>
      )}
      {/* Member avatars (card 2) */}
      {card.members && (
        <div style={{ display: "flex", alignItems: "center", gap: 6, margin: "6px 0 12px" }}>
          {card.members.map(m => (
            <div key={m.id} style={{ width: 26, height: 26, borderRadius: "50%", border: "2.5px solid rgba(255,255,255,.45)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 9, fontWeight: 800, color: "#fff", background: m.color }}>{m.id}</div>
          ))}
          {/* <span style={{ fontSize: 11, fontWeight: 700, color: "rgba(255,255,255,.85)" }}>{card.members?.length || 0} Members</span> */}
          <span style={{ fontSize: 11, fontWeight: 700, color: "rgba(255,255,255,.85)" }}>
            {totalMembers} Members
          </span>
        </div>
      )
      }
      {/* Divider */}
      <div style={{ height: 1, background: "rgba(255,255,255,.15)", margin: "0 0 12px" }} />
      {/* Chips */}
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginTop: "auto" }}>
        {(card.chips || []).map(chip => (
          <span key={chip} style={{ fontSize: 10, fontWeight: 700, color: "rgba(255,255,255,.95)", background: "rgba(255,255,255,.22)", padding: "4px 11px", borderRadius: 20 }}>{chip}</span>
        ))}
      </div>
    </div>
  );
}

/* ─────────────────────────── KPI POPUP ─────────────────────── */
function KpiPopup({ card, employees, onClose, colors}) {
  const { pop, gradient, label, value, chg } = card;
  const labels = employees[0]?.week?.labels || [];
  const completedColor = colors?.completed;
  const toDoColor = colors?.toDo;
  const backLogColor = colors?.backLog;
  const approvedColor = colors?.approved;
  const blockedColor = colors?.blocked;
  const rejectedColor = colors?.rejected;
  const transferredColor = colors?.transferred;
  const totalTaskColor = colors?.totalTask;
  // const fallbackColors = [
  //   "#3B82F6",
  //   "#EF4444",
  //   "#10B981",
  //   "#F59E0B",
  //   "#8B5CF6",
  //   "#EC4899",
  //   "#2563EB"
  // ];
  // const fallbackColors = [
  //   totalTaskColor,
  //   backLogColor,
  //   completedColor,
  //   blockedColor,
  //   approvedColor,
  //   transferredColor,
  //   toDoColor
  // ];
  const fallbackColors = [
    toDoColor,
    totalTaskColor,
    blockedColor,
    backLogColor,
    completedColor,

    approvedColor,
    transferredColor,

  ];
  const chartData = labels.map((day, i) => {
    const completed = employees.reduce(
      (sum, e) => sum + (e.week?.cp?.[i] || 0),
      0
    );

    const approved = employees.reduce(
      (sum, e) => sum + (e.week?.ap?.[i] || 0),
      0
    );
    const transferred = employees.reduce(
      (sum, e) => sum + (e.week?.tr?.[i] || 0),
      0
    );
    const rejected = employees.reduce(
      (sum, e) => sum + (e.week?.rj?.[i] || 0),
      0
    );
    return {
      name: day,
      Completed: completed,
      Approved: approved,
      Transferred: transferred,
    };
    // return {
    //   name: day,
    //   a: completed, // main bar
    //   b: approved   // secondary bar
    // };
  });
  const popChartData = chartData;
  // const popChartData = [
  //   { name: "Mon", a: 38, b: 8 }, { name: "Tue", a: 45, b: 12 }, { name: "Wed", a: 42, b: 10 },
  //   { name: "Thu", a: 52, b: 15 }, { name: "Fri", a: 48, b: 12 }, { name: "Sat", a: 56, b: 14 }, { name: "Sun", a: 38, b: 8 },
  // ];
  useEffect(() => {
    const handler = e => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [onClose]);

  return (
    <div onClick={e => { if (e.target === e.currentTarget) onClose(); }}
      style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.55)", zIndex: 300, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
      <div style={{ background: "#fff", borderRadius: 20, width: "95%", maxWidth: 520, maxHeight: "92vh", overflowY: "auto", boxShadow: "0 8px 48px rgba(0,0,0,.28)", animation: "kpipop .2s ease" }}>
        <style>{
          `@keyframes kpipop{from{opacity:0;transform:scale(.92) translateY(16px)}to{opacity:1;transform:scale(1) translateY(0)}}`}</style>

        {/* Header */}
        <div style={{ background: gradient, borderRadius: "20px 20px 0 0", padding: "22px 22px 18px", position: "relative", overflow: "hidden" }}>
          <div style={{ position: "absolute", right: -24, top: -24, width: 100, height: 100, borderRadius: "50%", background: "rgba(255,255,255,.1)", pointerEvents: "none" }} />
          <div style={{ position: "absolute", right: 16, top: 16, width: 54, height: 54, borderRadius: "50%", background: "rgba(255,255,255,.08)", pointerEvents: "none" }} />
          <button onClick={onClose} style={{ position: "absolute", top: 14, right: 14, width: 28, height: 28, borderRadius: "50%", background: "rgba(255,255,255,.2)", border: "none", cursor: "pointer", fontSize: 14, color: "#fff", zIndex: 2, display: "flex", alignItems: "center", justifyContent: "center" }}>✕</button>
          <div style={{ fontSize: 12, fontWeight: 800, color: "rgba(255,255,255,.75)", letterSpacing: ".08em", marginBottom: 6 }}>{label}</div>
          <div style={{ fontSize: 44, fontWeight: 800, color: "#fff", fontFamily: "'Outfit',sans-serif", lineHeight: 1 }}>{value}</div>
          <div style={{ fontSize: 11, color: "rgba(255,255,255,.7)", fontWeight: 600, marginTop: 4 }}>{pop?.sub || ""}</div>
          <div style={{ display: "inline-flex", alignItems: "center", gap: 4, fontSize: 10, fontWeight: 700, background: "rgba(255,255,255,.2)", color: "#fff", padding: "3px 10px", borderRadius: 20, marginTop: 8 }}>{chg}</div>
        </div>
        {/* Body */}
        <div style={{ padding: "18px 22px 22px" }}>
          {pop?.stats && (
            <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 10, marginBottom: 18 }}>
              {pop.stats.map(s => (
                <div key={s.l} style={{ background: "#F8F9FC", border: "1px solid rgba(0,0,0,.07)", borderRadius: 10, padding: "12px 14px", textAlign: "center" }}>
                  <div style={{ fontSize: 22, fontWeight: 800, fontFamily: "'Outfit',sans-serif", color: "#1A1F2E" }}>{s.v}</div>
                  <div style={{ fontSize: 10, fontWeight: 700, color: "#9CA3AF", letterSpacing: ".05em", marginTop: 4 }}>{s.l}</div>
                </div>
              ))}
            </div>
          )}
          {pop?.chartLabel === "Weekly Task Volume" && (
            <>
              <div style={{ fontSize: 12, fontWeight: 800, color: "#9CA3AF", letterSpacing: ".07em", marginBottom: 10 }}>{pop.chartLabel}</div>
              <div style={{ height: 160, marginBottom: 18 }}>
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart data={popChartData} margin={{ top: 0, right: 0, bottom: 0, left: -20 }}>
                    <XAxis dataKey="name" tick={{ fontSize: 10, fill: "#9CA3AF" }} axisLine={false} tickLine={false} />
                    <YAxis tick={{ fontSize: 10, fill: "#9CA3AF" }} axisLine={false} tickLine={false} />
                    <Tooltip content={<CUSTOM_TOOLTIP_KPI1 />} />
                    <Bar dataKey="Completed"
                      name="Completed"
                      // fill={gradient.includes("F2647A") ? "#EF4444" : gradient.includes("42B0F0") ? "#3B82F6" : gradient.includes("1EC99B") ? "#10B981" : "#F59E0B"} 
                      fill={completedColor}
                      radius={[4, 4, 0, 0]} />
                    <Bar
                      dataKey="Approved"
                      name="Approved"
                      // fill="rgba(156,163,175,.35)" 
                      fill={approvedColor}
                      radius={[4, 4, 0, 0]} />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </>
          )}
          {pop?.chartLabel === "To Do Trend This Week" && (
            <>
              <div style={{ fontSize: 12, fontWeight: 800, color: "#9CA3AF", letterSpacing: ".07em", marginBottom: 10 }}>
                {pop.chartLabel}
              </div>
              <div style={{ height: 160, marginBottom: 10 }}>
                <ResponsiveContainer width="100%" height="100%">
                  <LineChart
                    data={(() => {
                      const labels = employees[0]?.week?.labels || ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
                      return labels.map((day, idx) => {
                        const point = { name: day };
                        employees.forEach(e => {
                          point[e.name] = e.week.ip?.[idx] || 0;
                        });
                        return point;
                      });
                    })()}
                    margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
                  >
                    <XAxis dataKey="name" tick={{ fontSize: 10, fill: "#9CA3AF" }} axisLine={false} tickLine={false} />
                    <YAxis tick={{ fontSize: 10, fill: "#9CA3AF" }} axisLine={false} tickLine={false} />
                    <Tooltip />
                    {employees.map((e, index) => {
                      // Force fallback if e.color is undefined, null, or empty string
                      const color = fallbackColors[index % fallbackColors.length];

                      return (
                        <Line
                          key={e.name}
                          type="monotone"
                          dataKey={e.name}
                          stroke={color}
                          strokeWidth={2}
                          dot={(props) => {
                            const { cx, cy } = props;
                            return <circle key={`dot-${cx}-${cy}`} cx={cx} cy={cy} r={3} fill={color} stroke={color} />;
                          }}
                          activeDot={{ r: 5, fill: color }}
                        />
                      );
                    })}
                  </LineChart>
                </ResponsiveContainer>
              </div>
              {/* Custom legend */}
              <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginBottom: 18 }}>
                {employees.map((e, index) => {
                  const color = fallbackColors[index % fallbackColors.length];
                  return (
                    <div key={e.name} style={{ display: "flex", alignItems: "center", gap: 5 }}>
                      <div style={{ width: 24, height: 3, borderRadius: 2, background: color }} />
                      <span style={{ fontSize: 10, fontWeight: 600, color: "#9CA3AF" }}>{e.name}</span>
                    </div>
                  );
                })}
              </div>
            </>
          )}
          {/* {pop?.chartLabel === "In Progress Trend This Week" && (
            <>
              <div style={{ fontSize: 12, fontWeight: 800, color: "#9CA3AF", letterSpacing: ".07em", marginBottom: 10 }}>
                {pop.chartLabel}
              </div>
              <div style={{ height: 160, marginBottom: 18 }}>
                <ResponsiveContainer width="100%" height="100%">
                  <LineChart
                    data={(() => {
                      const labels = employees[0]?.week?.labels || ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
                      return labels.map((day, idx) => {
                        const point = { name: day };
                        employees.forEach(e => {
                          point[e.name] = e.week.inprogress?.[idx] || 0;
                        });
                        return point;
                      });
                    })()}
                    margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
                  >
                    <XAxis dataKey="name" tick={{ fontSize: 10, fill: "#9CA3AF" }} axisLine={false} tickLine={false} />
                    <YAxis tick={{ fontSize: 10, fill: "#9CA3AF" }} axisLine={false} tickLine={false} />
                    <Tooltip />
                    <Legend verticalAlign="top" height={36} />
                    {employees.map((e, index) => (
                      <Line
                        key={e.name}
                        type="monotone"
                        dataKey={e.name}
                        stroke={e.color || fallbackColors[index % fallbackColors.length]}
                        strokeWidth={2}
                        dot={{ r: 3 }}
                        activeDot={{ r: 5 }}
                      />
                    ))}
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </>
          )} */}
          {pop?.chartLabel === "Daily Completion This Week" && (
            <>
              <div style={{ fontSize: 12, fontWeight: 800, color: "#9CA3AF", letterSpacing: ".07em", marginBottom: 10 }}>{pop.chartLabel}</div>
              <div style={{ height: 160, marginBottom: 18 }}>
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart data={popChartData} margin={{ top: 0, right: 0, bottom: 0, left: -20 }}>
                    <XAxis dataKey="name" tick={{ fontSize: 10, fill: "#9CA3AF" }} axisLine={false} tickLine={false} />
                    <YAxis tick={{ fontSize: 10, fill: "#9CA3AF" }} axisLine={false} tickLine={false} />
                    <Tooltip content={<CUSTOM_TOOLTIP_KPI1 />} />
                    <Bar dataKey="Completed"
                      name="Completed"
                      //  fill={gradient.includes("F2647A") ? "#EF4444" : gradient.includes("42B0F0") ? "#3B82F6" : gradient.includes("1EC99B") ? "#10B981" : "#F59E0B"} radius={[4, 4, 0, 0]} />
                      fill={completedColor} />
                    <Bar
                      dataKey="Transferred"
                      name="Transferred"
                      // fill="rgba(156,163,175,.35)" 
                      fill={transferredColor}
                      radius={[4, 4, 0, 0]} />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </>
          )}

          {pop?.chartLabel === "Weekly Approval Trend" && (
            <>
              <div style={{ fontSize: 12, fontWeight: 800, color: "#9CA3AF", letterSpacing: ".07em", marginBottom: 10 }}>{pop.chartLabel}</div>
              <div style={{ height: 160, marginBottom: 18 }}>
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart data={popChartData} margin={{ top: 0, right: 0, bottom: 0, left: -20 }}>
                    <XAxis dataKey="name" tick={{ fontSize: 10, fill: "#9CA3AF" }} axisLine={false} tickLine={false} />
                    <YAxis tick={{ fontSize: 10, fill: "#9CA3AF" }} axisLine={false} tickLine={false} />
                    <Tooltip content={<CUSTOM_TOOLTIP_KPI1 />} />
                    <Bar
                      dataKey="Rejected"
                      name="Rejected"
                      // fill={gradient.includes("F2647A") ? "#EF4444" : gradient.includes("42B0F0") ? "#3B82F6" : gradient.includes("1EC99B") ? "#10B981" : "#F59E0B"} 
                      fill={rejectedColor}
                      radius={[4, 4, 0, 0]} />
                    <Bar
                      dataKey="Approved"
                      name="Approved"
                      // fill="rgba(156,163,175,.35)" 
                      fill={approvedColor}
                      radius={[4, 4, 0, 0]} />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </>
          )}

          {pop?.breakdown && (
            <>
              <div style={{ fontSize: 12, fontWeight: 800, color: "#9CA3AF", letterSpacing: ".07em", marginBottom: 10 }}>{pop.bkLabel || "Breakdown"}</div>
              <div style={{ display: "flex", flexDirection: "column", gap: 9, marginBottom: 18 }}>
                {pop.breakdown.map(b => {
                  const pct = Math.round((b.v / b.max) * 100);
                  return (
                    <div key={b.lbl} style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      <div style={{ width: 8, height: 8, borderRadius: "50%", background: b.dot, flexShrink: 0 }} />
                      <div style={{ fontSize: 11, fontWeight: 600, color: "#1A1F2E", flex: 1 }}>{b.lbl}</div>
                      <div style={{ flex: 2, height: 6, background: "#F8F9FC", borderRadius: 3, overflow: "hidden", border: "1px solid rgba(0,0,0,.07)" }}>
                        <div style={{ height: "100%", width: `${pct}%`, background: b.dot, borderRadius: 3 }} />
                      </div>
                      <div style={{ fontSize: 11, fontWeight: 700, color: "#1A1F2E", fontFamily: "'Outfit',sans-serif", width: 36, textAlign: "right" }}>{b.v}</div>
                      {b.bc && <Badge bc={b.bc}>{b.badge}</Badge>}
                    </div>
                  );
                })}
              </div>
            </>
          )}
          {pop?.actions && (
            <>
              <div style={{ fontSize: 12, fontWeight: 800, color: "#9CA3AF", letterSpacing: ".07em", marginBottom: 10 }}>Action Items</div>
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                {pop.actions.map(a => (
                  <div key={a.nm} style={{ display: "flex", alignItems: "center", gap: 10, background: "#F8F9FC", border: "1px solid rgba(0,0,0,.07)", borderRadius: 8, padding: "10px 12px" }}>
                    <div style={{ width: 28, height: 28, borderRadius: 7, background: a.bg, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                      <svg viewBox="0 0 20 20" fill={a.ico} width={14} height={14}><path d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4l-1.293 1.293a1 1 0 101.414 1.414l1.586-1.586A1 1 0 0011 10V6z" /></svg>
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: 11, fontWeight: 700, color: "#1A1F2E" }}>{a.nm}</div>
                      <div style={{ fontSize: 9, color: "#9CA3AF", fontWeight: 600, marginTop: 1 }}>{a.sub}</div>
                    </div>
                    {a.bc && <Badge bc={a.bc}>{a.badge}</Badge>}
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

/* ─────────────────────────── EMP MODAL ─────────────────────── */
function EmpModal({ emp, onClose }) {
  const [tab, setTab] = useState("week");
  const d = tab === "week" ? emp.week : emp.month;
  const chartData = d.labels.map((l, i) => ({ name: l, Approved: d.ap[i], Completed: d.cp[i] }));

  useEffect(() => {
    const h = e => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, [onClose]);

  const pctColor = emp.pct >= 85 ? "#10B981" : emp.pct >= 75 ? "#3B82F6" : emp.pct >= 65 ? "#F59E0B" : "#EF4444";

  return (
    <div onClick={e => { if (e.target === e.currentTarget) onClose(); }}
      style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.5)", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ background: "#fff", borderRadius: 16, border: "1px solid rgba(0,0,0,.07)", padding: 24, width: "95%", maxWidth: 580, maxHeight: "90vh", overflowY: "auto", boxShadow: "0 4px 28px rgba(0,0,0,.14)", animation: "kpipop .18s ease" }}>
        {/* Header */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 18 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 13 }}>
            <div style={{ width: 46, height: 46, borderRadius: "50%", background: emp.color, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16, fontWeight: 700, color: "#fff" }}>{emp.id}</div>
            <div>
              <div style={{ fontSize: 15, fontWeight: 800, color: "#1A1F2E" }}>{emp.name}</div>
              <div style={{ fontSize: 11, color: "#9CA3AF", marginTop: 2, fontWeight: 600 }}>{emp.role}</div>
            </div>
          </div>
          <button onClick={onClose} style={{ width: 30, height: 30, borderRadius: "50%", border: "1px solid rgba(0,0,0,.13)", background: "#F8F9FC", cursor: "pointer", fontSize: 15, color: "#6B7280", display: "flex", alignItems: "center", justifyContent: "center" }}>✕</button>
        </div>
        <div style={{ height: 1, background: "rgba(0,0,0,.07)", margin: "0 0 16px" }} />
        {/* Stats */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 9, marginBottom: 18 }}>
          {[{ v: emp.tasks, l: "Total", c: "" }, { v: emp.approved, l: "Approved", c: "#10B981" }, { v: emp.completed, l: "Completed", c: "#22C55E" }, { v: emp.backlog, l: "Backlog", c: "#EF4444" }].map(s => (
            <div key={s.l} style={{ background: "#F8F9FC", border: "1px solid rgba(0,0,0,.07)", borderRadius: 10, padding: 12, textAlign: "center" }}>
              <div style={{ fontSize: 22, fontWeight: 800, color: s.c || "#1A1F2E", fontFamily: "'Outfit',sans-serif" }}>{s.v}</div>
              <div style={{ fontSize: 10, fontWeight: 700, color: "#9CA3AF", marginTop: 3 }}>{s.l}</div>
            </div>
          ))}
        </div>
        {/* Completion */}
        <div style={{ display: "flex", justifyContent: "space-between", fontSize: 11, fontWeight: 700, color: "#6B7280", marginBottom: 6 }}>
          <span>Completion Rate</span><span style={{ color: pctColor, fontFamily: "'Outfit',sans-serif" }}>{emp.pct}%</span>
        </div>
        <div style={{ height: 7, background: "#F8F9FC", borderRadius: 4, overflow: "hidden", border: "1px solid rgba(0,0,0,.07)", marginBottom: 18 }}>
          <div style={{ height: "100%", width: `${emp.pct}%`, background: pctColor, borderRadius: 4, transition: "width .6s" }} />
        </div>
        {/* Tabs */}
        <div style={{ display: "flex", gap: 4, background: "#F8F9FC", padding: 3, borderRadius: 7, width: "fit-content", border: "1px solid rgba(0,0,0,.07)", marginBottom: 14 }}>
          {["week", "month"].map(t => (
            <button key={t} onClick={() => setTab(t)} style={{ fontSize: 11, fontWeight: 700, padding: "6px 16px", borderRadius: 5, border: "none", cursor: "pointer", background: tab === t ? "#00B9AE" : "transparent", color: tab === t ? "#fff" : "#6B7280", transition: "all .2s" }}>
              {t === "week" ? "This Week" : "This Month"}
            </button>
          ))}
        </div>
        {/* Chart */}
        <div style={{ height: 200 }}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={chartData} margin={{ top: 0, right: 0, bottom: 0, left: -20 }}>
              <XAxis dataKey="name" tick={{ fontSize: 11, fill: "#9CA3AF" }} axisLine={false} tickLine={false} />
              <YAxis tick={{ fontSize: 11, fill: "#9CA3AF" }} axisLine={false} tickLine={false} />
              <Tooltip content={<CUSTOM_TOOLTIP />} />
              <Bar dataKey="Approved" fill={emp.color + "CC"} radius={[6, 6, 0, 0]} />
              <Bar dataKey="Completed" fill="#10B981CC" radius={[6, 6, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>

        <div style={{ display: "flex", gap: 10, marginTop: 10 }}>
          {[{ c: emp.color, l: "Approved" }, { c: "#10B981", l: "Completed" }].map(l => (
            <div key={l.l} style={{ display: "flex", alignItems: "center", gap: 5, fontSize: 10, fontWeight: 600, color: "#6B7280" }}>
              <div style={{ width: 9, height: 9, borderRadius: 2, background: l.c }} />{l.l}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
function DrillDownModal({ drill, tasks, onClose }) {
  if (!drill) return null;

  const taskTypeMap = {
    backlog: "Backlog",
    todo: "To Do",
    completed: "Completed",
    approved: "Approved",
    inprogress: "To Do"
  };

  const colorMap = {
    backlog: '#f43f5e',
    todo: '#f59e0b',
    completed: '#10b981',
    approved: '#818cf8',
    inprogress: '#f59e0b'
  };

  const getColor = () => {
    const color = colorMap[drill.type];
    return color || '#06b6d4';
  };

  const drillTasks = tasks || [];
  const displayColor = getColor();

  const hexToRgb = (hex) => {
    if (!hex || hex.length < 7) return '100,100,100';
    try {
      const r = parseInt(hex.slice(1, 3), 16);
      const g = parseInt(hex.slice(3, 5), 16);
      const b = parseInt(hex.slice(5, 7), 16);
      return `${r},${g},${b}`;
    } catch (e) {
      return '100,100,100';
    }
  };

  const rgb = hexToRgb(displayColor);

  return (
    <div onClick={e => { if (e.target === e.currentTarget) onClose(); }} style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.7)', zIndex: 600, display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(4px)' }}>
      <div style={{ background: '#fff', borderRadius: 16, width: 1000, maxWidth: '95vw', maxHeight: '85vh', boxShadow: '0 24px 64px rgba(0,0,0,0.25)', animation: 'modalIn .22s ease', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '18px 24px 16px', borderBottom: '1px solid rgba(0,0,0,0.07)', background: `linear-gradient(135deg, rgba(${rgb}, 0.08) 0%, transparent 100%)` }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{ width: 40, height: 40, borderRadius: 10, background: displayColor, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 700, fontSize: 18 }}>
              {drillTasks.length}
            </div>
            <div>
              <div style={{ fontFamily: "'Outfit',sans-serif", fontSize: 16, fontWeight: 700, color: '#1e293b' }}>
                {taskTypeMap[drill.type] || 'Tasks'}
              </div>
              {drill.source === "tillDate" ? (
                <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>
                  View: All Tasks
                </div>
              ) :
                <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>
                  View: {drill.view?.toUpperCase() || 'N/A'}
                </div>}
            </div>
          </div>
          <button onClick={onClose} style={{ width: 32, height: 32, borderRadius: '50%', background: '#f1f5f9', border: 'none', cursor: 'pointer', color: '#64748b', fontSize: 18, fontWeight: 600, transition: 'all .18s' }} onMouseEnter={e => e.currentTarget.style.background = '#e2e8f0'} onMouseLeave={e => e.currentTarget.style.background = '#f1f5f9'}>✕</button>
        </div>

        {/* Table Container */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '0' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead style={{ position: 'sticky', top: 0, backgroundColor: '#f8fafc', zIndex: 10 }}>
              <tr>
                {["#", "Task Name", "Project", "Type", "Sprint", "Status"].map((h) => (
                  <th key={h} style={{ fontSize: 10, letterSpacing: 0.8, color: '#94a3b8', fontWeight: 700, padding: '12px 10px', textAlign: 'left', background: '#f8fafc', borderBottom: '1px solid rgba(0,0,0,0.07)', minWidth: h === "Task Name" ? '200px' : 'auto' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {drillTasks.map((task, i) => (
                <tr key={task.id || i} style={{ borderBottom: '1px solid rgba(0,0,0,0.05)', transition: 'background .15s' }} onMouseEnter={(e) => (e.currentTarget.style.background = "#f8fafc")} onMouseLeave={(e) => (e.currentTarget.style.background = "")}>
                  <td style={{ padding: '10px 10px', fontSize: 11, color: '#64748b', fontWeight: 600, width: '40px' }}>{String(i + 1).padStart(2, "0")}</td>
                  <td style={{ padding: '10px 10px', fontSize: 12, color: '#1e293b', fontWeight: 500 }}>
                    <span style={{ display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={task.name}>{task.name}</span>
                  </td>
                  <td style={{ padding: '10px 10px', fontSize: 11 }}>
                    <span style={{ fontSize: 10, background: '#f1f5f9', padding: '3px 8px', borderRadius: 5, color: '#475569', fontWeight: 700, display: 'inline-block' }}>{task.project || '—'}</span>
                  </td>
                  <td style={{ padding: '10px 10px', fontSize: 11 }}>
                    <span style={{ fontSize: 10, background: '#e0f2fe', padding: '3px 8px', borderRadius: 5, color: '#0284c7', fontWeight: 600, display: 'inline-block' }}>{task.type || '—'}</span>
                  </td>
                  <td style={{ padding: '10px 10px', fontSize: 11, color: '#64748b' }}>
                    <span style={{ fontSize: 10, fontWeight: 600 }}>{task.sprint || 'N/A'}</span>
                  </td>
                  {/* <td style={{ padding: '10px 10px', fontSize: 11, color: '#1e293b', fontWeight: 500 }}>
                    {task.by || task.assignee || task.assignedTo || '—'}
                  </td> */}
                  <td style={{ padding: '10px 10px', fontSize: 11 }}>
                    <Badge status={task.status} />
                  </td>
                </tr>
              ))}
              {drillTasks.length === 0 && (
                <tr>
                  <td colSpan={7} style={{ textAlign: 'center', padding: 32, color: '#94a3b8', fontSize: 13 }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}>
                      <svg width="40" height="40" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24" style={{ opacity: 0.3 }}><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" /></svg>
                      No tasks found.
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Footer */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 24px', borderTop: '1px solid rgba(0,0,0,0.07)', background: '#f8fafc' }}>
          <div style={{ fontSize: 11, color: '#64748b', fontWeight: 600 }}>
            Showing {drillTasks.length} {drillTasks.length === 1 ? 'task' : 'tasks'}
          </div>
          <button onClick={onClose} style={{ padding: '8px 16px', borderRadius: 8, border: '1px solid rgba(0,0,0,0.1)', background: '#fff', color: '#64748b', cursor: 'pointer', fontSize: 12, fontWeight: 600, transition: 'all .18s' }} onMouseEnter={e => { e.currentTarget.style.background = '#f1f5f9'; e.currentTarget.style.borderColor = '#101214'; }} onMouseLeave={e => { e.currentTarget.style.background = '#fff'; e.currentTarget.style.borderColor = 'rgba(0,0,0,0.1)'; }}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
// ✅ FIXED: Handle chart click events with proper type detection


/* ─────────────────────────────────────────────
   CUSTOM TOOLTIP for main chart
───────────────────────────────────────────────*/
const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <Paper elevation={3} sx={{ p: 1.5, minWidth: 160, border: "1px solid #e5e7eb", borderRadius: 2 }}>
      <Typography sx={{ fontSize: 12, fontWeight: 800, color: "#113fd4", mb: 0.5 }}>{label}</Typography>
      {payload.map(C => (
        <Box key={C.dataKey} sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 0.3 }}>
          <Box sx={{ width: 8, height: 8, borderRadius: 1, background: C.fill, flexShrink: 0 }} />
          <Typography sx={{ fontSize: 11, color: "#374151" }}>{C.dataKey}: <b>{C.value}</b></Typography>
        </Box>
      ))}
    </Paper>
  );
};

/* ─────────────────────────────────────────────
   DRILLDOWN DIALOG
───────────────────────────────────────────────*/
const DrilldownDialog = ({ open, employee, onClose,colors }) => {
  const [activeProjIdx, setActiveProjIdx] = useState(0);
  const [taskFilter, setTaskFilter] = useState("all");
  const [projectFilter, setProjectFilter] = useState("all");
  const completedColor = colors?.completed;
  const toDoColor = colors?.toDo;
  const backLogColor = colors?.backLog;
  const approvedColor = colors?.approved;
  const blockedColor = colors?.blocked;
  const rejectedColor = colors?.rejected;
  const transferredColor = colors?.transferred;
  const totalTaskColor = colors?.totalTask;

  useEffect(() => {
    if (open) {
      setTaskFilter("all");
      setProjectFilter("all");
    }
  }, [open, employee]);

  if (!open) return null;

  // if (!employee) return null;

  /* ✅ FLATTEN ALL TASKS FROM PROJECTS */
  const allTasks =
    employee?.projects?.flatMap((project) =>
      (project.taskList || []).map((task) => ({
        ...task,
        projectName: project.projectName,
      }))
    ) || [];
  const normalizeStatus = (status) => {
    if (!status) return "";

    const s = status.toUpperCase();

    if (s === "APPROVED" || s === "AP") return "AP";
    if (s === "COMPLETED" || s === "C") return "C";
    if (s === "BACKLOG" || s === "SH" || s === "AS") return "AS";
    if (s === "INPROGRESS" || s === "I") return "I";
    if (s === "TRANSFERRED" || s === "TO") return "TO";
    if (s === "BLOCKED" || s === "B") return "B";
    if (s === "REJECTED" || s === "RJ") return "RJ";

    return s;
  };

  /* ✅ FILTER */
  // const filteredTasks =
  //   taskFilter === "all"
  //     ? allTasks
  //     : allTasks.filter(
  //       (t) => normalizeStatus(t.status) === taskFilter
  //     );

  const filteredTasks = allTasks.filter((t) => {
    const statusMatch =
      taskFilter === "all" ||
      normalizeStatus(t.status) === taskFilter;

    const projectMatch =
      projectFilter === "all" ||
      t.projectName === projectFilter;

    return statusMatch && projectMatch;
  });
  /* ✅ COUNTS */
  const totalTasks = allTasks.length;
  const completed = allTasks.filter((t) => normalizeStatus(t.status) === "C").length;
  const approved = allTasks.filter((t) => normalizeStatus(t.status) === "AP").length;
  const backlog = allTasks.filter((t) => (normalizeStatus(t.status) === "AS" || normalizeStatus(t.status) === "SH")).length;
  const blocked = allTasks.filter((t) => normalizeStatus(t.status) === "B").length;
  const inprogress = allTasks.filter((t) => normalizeStatus(t.status) === "I").length;
  const transferred = allTasks.filter((t) => normalizeStatus(t.status) === "TO").length;
  const rejected = allTasks.filter((t) => normalizeStatus(t.status) === "RJ").length;

  /* ✅ SAFE % */
  const safePct = (val) =>
    totalTasks ? `${Math.round((val / totalTasks) * 100)}%` : "0%";

  /* ✅ PROJECT CHART */
  const projChartData = (employee?.projects || []).map((p) => ({
    name: p.projectName,
    Tasks: p.tasks || 0,
    Approved: p.approved || 0,
    Completed: p.completed || 0,
    Transferred: p.transferred || 0,
    InProgress: p.inprogress || 0,
    Backlog: p.backlog || 0,
  }));

  const STATUS_CHIP = {
    AP: { label: "Approved", bg: "#eaf3de", color: approvedColor },
    C: { label: "Completed", bg: "#e1f5ee", color: completedColor },
    I: { label: "To Do", bg: "#faeeda", color: toDoColor },
    B: { label: "Blocked", bg: "#fcebeb", color: blockedColor },
    TO: { label: "Transferred", bg: "#eeedfe", color: transferredColor },
    AS: { label: "Backlog", bg: "#fcebeb", color: backLogColor },
    RJ: { label: "Rejected", bg: "#fcebeb", color: rejectedColor },
  };

  const distinctStatuses = [
    "all",
    ...new Set(allTasks.map((t) => normalizeStatus(t.status))),
  ];
  const distinctProjects = [
    "all",
    ...new Set(allTasks.map((t) => t.projectName))
  ];
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>

        <Box>
          <Typography variant="h5" fontWeight="bold">
            Performance Breakdown
          </Typography>
          <Typography variant="h6" sx={{ fontSize: 14 }}>
            {employee ? `${employee.name} - (${totalTasks})` : "Loading..."}
          </Typography>
        </Box>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        {!employee ? (
          <Typography>Loading...</Typography>
        ) : (
          <>
            {/* KPI */}
            <Grid container spacing={2} sx={{ mb: 2, display: "flex", justifyContent: "center" }}>
              {[
                // { label: "Total", value: totalTasks, border: `2px solid ${totalTaskColor}`, color: totalTaskColor },
                { label: "Approved", value: approved, border: `2px solid ${approvedColor}`, color: approvedColor },
                { label: "Completed", value: completed, border: `2px solid ${completedColor}`, color: completedColor },
                { label: "In Progress", value: inprogress, border: `2px solid ${toDoColor}`, color: toDoColor },
                { label: "Transferred", value: transferred, border: `2px solid ${transferredColor}`, color: transferredColor },
                { label: "Backlog", value: backlog, border: `2px solid ${backLogColor}`, color: backLogColor },
                { label: "Blocked", value: blocked, border: `2px solid ${blockedColor}`, color: blockedColor },
                { label: "Rejected", value: rejected, border: `2px solid ${rejectedColor}`, color: rejectedColor },
              ].map((k) => (
                <Grid item xs={4} sm={2} md={1.5} key={k.label}>
                  <Paper sx={{ p: 0.5, textAlign: "center", borderRadius: "15px" }}>
                    <Typography fontWeight="bold" color={k.color}>
                      {k.value}
                    </Typography>
                    <Typography variant="caption" color={k.color}>
                      {k.label}
                    </Typography>
                  </Paper>
                </Grid>
              ))}
            </Grid>

            {/* FILTER */}
            <Box sx={{ display: "flex", gap: 1, mb: 2, flexWrap: "wrap" }}>
              {distinctProjects.map((p) => (
                <Chip
                  key={p}
                  label={p === "all" ? "All Projects" : p}
                  onClick={() => setProjectFilter(p)}
                  sx={{
                    fontWeight: 600,
                    bgcolor: projectFilter === p ? completedColor : "#f3f4f6",
                    color: projectFilter === p ? "#fff" : "#374151",
                    "&:hover": {
                      bgcolor: projectFilter === p ? completedColor : "#e5e7eb",
                    }
                  }}
                />
              ))}
            </Box>
            <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
              {distinctStatuses.map((s) => (
                <Chip
                  key={s}
                  label={s === "all" ? "All" : STATUS_CHIP[s]?.label || s}
                  onClick={() => setTaskFilter(s)}
                  sx={{
                    fontWeight: 600,
                    bgcolor: taskFilter === s ? toDoColor : "#f3f4f6",
                    color: taskFilter === s ? "#fff" : "#374151",
                    "&:hover": {
                      bgcolor: taskFilter === s ? toDoColor : "#e5e7eb",
                    }
                  }}
                />
              ))}
            </Box>

            {/* TASK LIST */}
            <Box
              sx={{
                border: "1px solid #e5e7eb",
                borderRadius: 2,
                overflow: "hidden",
              }}
            >
              {/* SCROLL WRAPPER */}
              <Box sx={{ overflowX: "auto" }}>
                <Box sx={{ minWidth: 700 }}>

                  {/* HEADER */}
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "40px 2.5fr 1.5fr 1.2fr 1fr 1fr",
                      background: "#f9fafb",
                      p: 1,
                      fontWeight: 700,
                      fontSize: 12,
                      borderBottom: "1px solid #e5e7eb",
                      position: "sticky",
                      top: 0,
                      zIndex: 2
                    }}
                  >
                    <div>#</div>
                    <div>Task</div>
                    <div>Project</div>
                    <div>Date</div>
                    <div>Priority</div>
                    <div>Status</div>
                  </Box>

                  {/* ROWS */}
                  {filteredTasks.map((task, index) => {
                    const statusKey = normalizeStatus(task.status);
                    const sc = STATUS_CHIP[statusKey] || {};

                    return (
                      <Box
                        key={task.id}
                        sx={{
                          display: "grid",
                          gridTemplateColumns: "40px 2.5fr 1.5fr 1.2fr 1fr 1fr",
                          p: 1,
                          borderBottom: "1px solid #f1f1f1",
                          alignItems: "center",
                          "&:hover": { background: "#fafafa" }
                        }}
                      >
                        {/* SL NO */}
                        <Typography fontSize={12}>
                          {index + 1}
                        </Typography>

                        {/* TASK */}
                        <Typography
                          fontSize={12}
                          fontWeight={600}
                          sx={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                          }}
                          title={task.desc}
                        >
                          {task.name || task.desc}
                        </Typography>

                        {/* PROJECT */}
                        <Typography
                          fontSize={11}
                          color="text.secondary"
                          sx={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                          }}
                          title={task.projectName}
                        >
                          {task.projectName}
                        </Typography>

                        {/* DATE */}
                        <Typography fontSize={11} color="text.secondary">
                          {task.date || "-"}
                        </Typography>

                        {/* PRIORITY */}
                        <Chip
                          size="small"
                          label={task.priority || "N/A"}
                          sx={{
                            fontWeight: 600,
                            width: "fit-content",
                            // bgcolor: sc.bg,
                            // color: sc.color,
                          }}
                        />

                        {/* STATUS */}
                        <Chip
                          size="small"
                          label={sc.label || statusKey}
                          sx={{
                            bgcolor: sc.bg,
                            color: sc.color,
                            fontWeight: 600,
                            width: "fit-content"
                          }}
                        />
                      </Box>
                    );
                  })}

                  {/* EMPTY */}
                  {filteredTasks.length === 0 && (
                    <Box sx={{ p: 2, textAlign: "center" }}>
                      <Typography>No tasks found</Typography>
                    </Box>
                  )}

                </Box>
              </Box>
            </Box>

          </>)}
      </DialogContent>
    </Dialog>
  );
};
/* ─────────────────────────── MAIN APP ─────────────────────── */
export default function ManagerDashboard() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const listViewurl = useSelector((state) => state.globalurl?.listViewurl);
  const [viewType, setViewType] = useState("week"); // "week" | "month"
  // Get session data
  const empID = sessionStorage.getItem("EmpId");
  const compID = sessionStorage.getItem("companyId");
  const isManager = sessionStorage.getItem("isManager");

  const [collapsed, setCollapsed] = useState(false);
  const [dark, setDark] = useState(false);
  const [kpiPopup, setKpiPopup] = useState(null);
  const [empModal, setEmpModal] = useState(null);
  const [drillModal, setDrillModal] = useState(null);
  const [metric, setMetric] = useState("all");
  const [empFilter, setEmpFilter] = useState("all");
  const [isCalendar, setIsCalendar] = useState(false);
  const [selectedEmp, setSelectedEmp] = useState(null);
  const params = useParams();
  const EmpName = sessionStorage.getItem("EmpName");
  const [wtdView, setWtdView] = useState('w2d');
  const [openModal, setOpenModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  //TEAM PERFORMANCE OVERVIEW
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [openDrilldown, setOpenDrilldown] = useState(false);

  // Get data from Redux
  const dashboardDataV2 = useSelector((state) => state.loginApi?.dashboardDataV2);
  const loadingV2 = useSelector((state) => state.loginApi?.loadingV2);
  // Extract data from API response
  const employees = dashboardDataV2?.employees || [];
  const teamPerformanceData = dashboardDataV2?.teamPerformance || {};
  const workloadDataFromAPI = dashboardDataV2?.workloadData || [];
  const leaveData = dashboardDataV2?.leaveData || [];
  const priorityDataFromAPI = dashboardDataV2?.priorityData || [];
  const kpiCardsData = dashboardDataV2?.kpiCards || [];
  const approvedbymeData = dashboardDataV2?.approvedbymeData?.[0] || {};
  const drillTasks = approvedbymeData || {};
  const wtdChartData = useMemo(() => Array.isArray(approvedbymeData?.[wtdView]) ? approvedbymeData[wtdView] : [], [approvedbymeData, wtdView]);
  
  const overallColors = dashboardDataV2?.Colours || [];
  const completedColor = overallColors?.completed;
  const toDoColor = overallColors?.toDo;
  const backLogColor = overallColors?.backLog;
  const approvedColor = overallColors?.approved;
  const blockedColor = overallColors?.blocked;
  const rejectedColor = overallColors?.rejected;
  const transferredColor = overallColors?.transferred;
  const totalTaskColor = overallColors?.totalTask;
  const KPIGradient1 = overallColors?.kpi1;
  const KPIGradient2 = overallColors?.kpi2;
  const KPIGradient3 = overallColors?.kpi3;
  const KPIGradient4 = overallColors?.kpi4;

  const getGreeting = () => {
    const hour = new Date().getHours();

    if (hour < 12) return "Good Morning";
    if (hour < 17) return "Good Afternoon";
    return "Good Evening";
  };
  const handleWTDChartClick = (state) => {
    if (!state || !state.activeTooltipIndex) return;

    const dataIndex = state.activeTooltipIndex;
    const chartData = wtdChartData[dataIndex];

    // Skip "Total" - it has a special key
    if (chartData?.key === 'total') return;

    // Valid task types: backlog, todo, completed, approved
    const validTypes = ['backlog', 'todo', 'completed', 'approved'];
    if (chartData?.key && validTypes.includes(chartData.key)) {
      setDrillModal({ view: wtdView, type: chartData.key, filter: 'all' });
    }
  };

  // Calculate totals dynamically
  const calculateTotals = () => {
    if (employees.length === 0)
      return { totalTasks: 0, totalApproved: 0, totalCompleted: 0, totalTransferred: 0, totalInProgress: 0, totalBacklog: 0 };

    return {
      totalTasks: employees.reduce((sum, e) => sum + (e.tasks || 0), 0),
      totalApproved: employees.reduce((sum, e) => sum + (e.approved || 0), 0),
      totalCompleted: employees.reduce((sum, e) => sum + (e.completed || 0), 0),
      totalTransferred: employees.reduce((sum, e) => sum + (e.transferred || 0), 0),
      totalInProgress: employees.reduce((sum, e) => sum + (e.inprogress || 0), 0),
      totalBacklog: employees.reduce((sum, e) => sum + (e.backlog || 0), 0),
      totalBlocked: employees.reduce((sum, e) => sum + (e.blocked || 0), 0),
      totalRejected: employees.reduce((sum, e) => sum + (e.rejected || 0), 0),
    };
  };
  const totalTasks = employees.reduce((sum, e) => sum + (e.tasks || 0), 0);

  const totalInProgress = employees.reduce((sum, e) => sum + (e.inprogress || 0), 0);

  const totalCompleted = employees.reduce((sum, e) => sum + (e.completed || 0), 0);

  const teamCapacity = totalTasks
    ? Math.round(((totalInProgress + totalCompleted) / totalTasks) * 100)
    : 0;
  const chartSeries = employees.map(e => ({
    name: e.name,
    data: e.week.ip || []  // daily counts of tasks in progress Mon-Sun
  }));
  const chartLabels = employees[0]?.week.labels || ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
  const totals = calculateTotals();
  const teamWeekly = Array.from({ length: employees[0]?.week?.cp?.length || 0 }, (_, i) =>
    employees.reduce((sum, e) => sum + (e.week.cp[i] || 0), 0)
  );

  const max = Math.max(...teamWeekly, 1);

  const sparkHeights = teamWeekly.map(v =>
    Math.round((v / max) * 100)
  );
  console.log(sparkHeights, "sparkHeights id :1");
  // Generate KPI Cards from API data
  // const fallbackColors = [
  //   "#3B82F6",
  //   "#EF4444",
  //   "#10B981",
  //   "#F59E0B",
  //   "#8B5CF6",
  //   "#EC4899",
  //   "#2563EB"
  // ];

  const fallbackColors = [
    toDoColor,
    totalTaskColor,
    blockedColor,
    backLogColor,
    completedColor,

    approvedColor,
    transferredColor,

  ];
  const weeklyCompletedTotal = employees.reduce(
    (sum, e) => sum + (e.week.cp?.reduce((s, v) => s + v, 0) || 0),
    0
  );

  const weeklyDays = employees[0]?.week?.cp?.length || 0;

  const avgDailyCompletion = weeklyDays
    ? Math.round(weeklyCompletedTotal / weeklyDays)
    : 0;
  const dailyTotals = employees[0]?.week?.cp?.map((_, i) =>
    employees.reduce((sum, e) => sum + (e.week.cp?.[i] || 0), 0)
  ) || [];

  const isDropping =
    dailyTotals.length >= 2 &&
    dailyTotals[dailyTotals.length - 1] < dailyTotals[dailyTotals.length - 2];
  const hasMore = employees.length > 8;
  const visibleMembers = employees.slice(0, hasMore ? 7 : 8);
  const generateKPICards = () => {
    const defaultIcon = <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" />;

    return [
      {
        id: 1,
        gradient: KPIGradient1,
        label: "Team Tasks",
        value: totals.totalTasks.toLocaleString(),
        // chg: "↑ 12%",
        chgUp: true,
        type: "spark",
        // sparkHeights: [45, 60, 50, 80, 65, 100, 85],
        sparkHeights: sparkHeights,
        chips: [`Backlog (${totals.totalBacklog})`, `To Do (${totals.totalInProgress})`, `Completed (${totals.totalCompleted})`, `Approved (${totals.totalApproved})`, `Transferred (${totals.totalTransferred})`],
        icon: <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v1h8v-1zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-1a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v1h-3zM4.75 14.094A5.973 5.973 0 004 17v1H1v-1a3 3 0 013.75-2.906z" />,
        pop: {
          sub: "Total tasks across all team members",
          stats: [
            { v: totals.totalInProgress.toString(), l: "To Do" },
            { v: totals.totalCompleted.toString(), l: "Completed" },
            { v: totals.totalBacklog.toString(), l: "Backlog" },
            { v: totals.totalApproved.toString(), l: "Approved" },
            { v: totals.totalTransferred.toString(), l: "Transferred" },
          ],
          chartLabel: "Weekly Task Volume",
          bkLabel: "Backlog by Member",
          breakdown: employees.map((e, idx) => ({
            dot: e.color || backLogColor,
            lbl: e.name,
            v: e.backlog || 0,
            max: Math.max(...employees.map(x => x.backlog || 0), 100),
            // badge: `${e.pct || 0}%`,
            badge: `${e.backlog == 0 ? "clear" : e.backlog} tasks`,
            bc: e.pct >= 85 ? "g" : e.pct >= 75 ? "b" : e.pct >= 65 ? "y" : "r"
          })),
          actions: [
            { bg: "#FEE2E2", ico: backLogColor, nm: `${totals.totalBacklog} Backlog Tasks Need Attention`, sub: "Not Picked Tasks", badge: "Urgent", bc: "r" },
            { bg: "#FEF3C7", ico: blockedColor, nm: `Team capacity at ${teamCapacity}%`, sub: "Consider workload rebalancing", badge: "Warning", bc: "y" },
            { bg: "#D1FAE5", ico: completedColor, nm: `${totals.totalCompleted} tasks completed this cycle`, sub: "Team velocity is strong", badge: "On Track", bc: "g" }
          ]
        }
      },
      // {
      //   id: 2,
      //   gradient: "linear-gradient(145deg,#42B0F0 0%,#1A93D5 100%)",
      //   label: "Team Completion Rate",
      //   value: employees.length > 0 ? Math.round(employees.reduce((sum, e) => sum + (e.pct || 0), 0) / employees.length) + "%" : "0%",
      //   // chg: "↑ 3%",
      //   chgUp: true,
      //   type: "progress",
      //   progLbl: `${employees.length} members avg`,
      //   progVal: `${employees.length > 0 ? Math.round(employees.reduce((sum, e) => sum + (e.pct || 0), 0) / employees.length) : 0} / 100`,
      //   progPct: employees.length > 0 ? Math.round(employees.reduce((sum, e) => sum + (e.pct || 0), 0) / employees.length) : 0,
      //   members: employees.slice(0, 4).map(e => ({ id: e.name?.split(' ').slice(0, 2).map(word => word[0]?.toUpperCase()).join(''), color: e.color || "#3B82F6" })),
      //   icon: defaultIcon,
      //   pop: {
      //     sub: `Average completion rate across ${employees.length} team members`,
      //     stats: employees.slice(0, 3).map(e => ({ v: `${e.pct || 0}%`, l: e.name.split(" ")[0] })),
      //     chartLabel: "Completion Rate Trend (4 Weeks)",
      //     bkLabel: "Individual Completion Rate",
      //     breakdown: employees.map(e => ({
      //       dot: e.color || "#3B82F6",
      //       lbl: e.name,
      //       v: e.pct || 0,
      //       max: 100,
      //       badge: e.pct >= 85 ? "↑ 2%" : e.pct >= 75 ? "↑ 1%" : e.pct >= 65 ? "→ 0%" : "↓ 1%",
      //       bc: e.pct >= 85 ? "g" : e.pct >= 75 ? "b" : e.pct >= 65 ? "y" : "r"
      //     })),
      //     actions: [
      //       { bg: "#FEE2E2", ico: "#EF4444", nm: "Some members below threshold", sub: "Review workload and blockers", badge: "Action Needed", bc: "r" },
      //       { bg: "#DBEAFE", ico: "#3B82F6", nm: "Team review scheduled", sub: "Tomorrow at 10:00 AM", badge: "Scheduled", bc: "b" },
      //       { bg: "#D1FAE5", ico: "#10B981", nm: "High performers identified", sub: "Commendation due this cycle", badge: "Great", bc: "g" }
      //     ]
      //   }
      // },
      {
        id: 2,
        gradient: KPIGradient2,
        label: "Team Completion Rate",
        value:
          employees.length > 0
            ? Math.round(
              employees.reduce((sum, e) => sum + (e.pct || 0), 0) / employees.length
            ) + "%"
            : "0%",
        chgUp: true,
        type: "progress",
        progLbl: `${employees.length} members avg`,
        progVal: `${employees.length > 0
          ? Math.round(employees.reduce((sum, e) => sum + (e.pct || 0), 0) / employees.length)
          : 0
          } / 100`,
        progPct:
          employees.length > 0
            ? Math.round(employees.reduce((sum, e) => sum + (e.pct || 0), 0) / employees.length)
            : 0,
        members: [
          ...visibleMembers.map((e, index) => ({
            id: e.name
              ?.split(" ")
              .slice(0, 2)
              .map(word => word[0]?.toUpperCase())
              .join(""),
            color: fallbackColors[index % fallbackColors.length]
          })),
          ...(hasMore
            ? [{ id: `+${employees.length - 7}`, color: "#9CA3AF" }]
            : [])
        ],
        // members: employees.slice(0, 30).map((e, index) => ({
        //   id: e.name
        //     ?.split(" ")
        //     .slice(0, 2)
        //     .map(word => word[0]?.toUpperCase())
        //     .join(""),
        //   color: fallbackColors[index % fallbackColors.length]
        // })),
        icon: defaultIcon,
        pop: {
          sub: `To Do Trend This Week`,
          stats: employees.slice(0, 3).map(e => ({
            v: (e.week.cp?.reduce((sum, val) => sum + val, 0) || 0).toString(),
            l: (e.name?.split(" ")?.[0]),
            // l: `Completed - ${e.name?.split(" ")?.[0]}`
          })),
          chartLabel: "To Do Trend This Week",
          bkLabel: "To Do Tasks By Member",
          breakdown: employees.map((e, index) => ({
            dot: fallbackColors[index % fallbackColors.length],
            lbl: e.name,
            v: e.week.ip ? e.week.ip.reduce((sum, val) => sum + val, 0) : 0,
            max: Math.max(...employees.map(x => x.week.ip?.reduce((s, v) => s + v, 0) || 0), 100),
            badge: "Tasks in progress",
            bc: "b"
          })),
          actions: (() => {
            const priority = { r: 1, y: 2, b: 3, g: 4 };

            const mapped = employees.map(e => {
              const completed = e.week.cp?.reduce((s, v) => s + v, 0) || 0;
              const inprogress = e.week.ip?.reduce((s, v) => s + v, 0) || 0;
              const backlog = e.week.bk?.reduce((s, v) => s + v, 0) || 0;

              const workload = inprogress + backlog;
              const totalTasks = completed + workload;

              const completionPct = totalTasks
                ? Math.round((completed / totalTasks) * 100)
                : 0;

              let bg, ico, badge, bc, nm, sub;

              if (workload > 15 && completionPct < 50) {
                bg = "#FEE2E2";
                ico = "#EF4444";
                badge = "Overload";
                bc = "r";
                nm = `${e.name} overloaded (${workload})`;
                sub = `Low completion (${completionPct}%)`;
              } else if (workload > 8 && completionPct < 70) {
                bg = "#FEF3C7";
                ico = "#F59E0B";
                badge = "Monitor";
                bc = "y";
                nm = `${e.name} moderate workload (${workload})`;
                sub = `Completion ${completionPct}%`;
              } else if (workload < 3 && completionPct < 50) {
                bg = "#E0F2FE";
                ico = "#0284C7";
                badge = "Low Work";
                bc = "b";
                nm = `${e.name} underutilized (${workload})`;
                sub = `Assign more tasks`;
              } else {
                bg = "#D1FAE5";
                ico = "#10B981";
                badge = "Efficient";
                bc = "g";
                nm = `${e.name} performing well`;
                sub = `${completionPct}% done`;
              }

              return { bg, ico, nm, sub, badge, bc };
            });

            // 🔥 Separate greens and others
            const nonGreen = mapped.filter(a => a.bc !== "g");
            const green = mapped.find(a => a.bc === "g"); // ✅ ONLY ONE

            const sortedNonGreen = nonGreen.sort(
              (a, b) => priority[a.bc] - priority[b.bc]
            );

            // 🔥 Combine: important alerts + ONE green
            const finalActions = green
              ? [...sortedNonGreen, green]
              : sortedNonGreen;

            return finalActions.slice(0, 5); // limit total
          })()
          // actions: employees.map(e => {
          //   const completed = e.week.cp?.reduce((s, v) => s + v, 0) || 0;
          //   const inprogress = e.week.ip?.reduce((s, v) => s + v, 0) || 0;
          //   const backlog = e.week.bk?.reduce((s, v) => s + v, 0) || 0;

          //   const workload = inprogress + backlog;
          //   const totalTasks = completed + workload;

          //   const completionPct = totalTasks
          //     ? Math.round((completed / totalTasks) * 100)
          //     : 0;

          //   let bg, ico, badge, bc, nm, sub;

          //   if (workload > 15 && completionPct < 50) {
          //     bg = "#FEE2E2";
          //     ico = "#EF4444";
          //     badge = "Overload";
          //     bc = "r";
          //     nm = `${e.name} overloaded (${workload})`;
          //     sub = `Low completion (${completionPct}%)`;
          //   } else if (workload > 8 && completionPct < 70) {
          //     bg = "#FEF3C7";
          //     ico = "#F59E0B";
          //     badge = "Monitor";
          //     bc = "y";
          //     nm = `${e.name} moderate workload (${workload})`;
          //     sub = `Completion ${completionPct}%`;
          //   } else if (workload < 3 && completionPct < 50) {
          //     bg = "#E0F2FE";
          //     ico = "#0284C7";
          //     badge = "Low Work";
          //     bc = "b";
          //     nm = `${e.name} underutilized (${workload})`;
          //     sub = `Assign more tasks`;
          //   } else {
          //     bg = "#D1FAE5";
          //     ico = "#10B981";
          //     badge = "Efficient";
          //     bc = "g";
          //     nm = `${e.name} performing well`;
          //     sub = `${completionPct}% done`;
          //   }

          //   return { bg, ico, nm, sub, badge, bc };
          // })
          // actions: employees.map(e => {
          //   const workload = (e.inprogress || 0) + (e.backlog || 0);

          //   let status = "Balanced";
          //   let bg = "#D1FAE5";
          //   let ico = "#10B981";
          //   let badge = "Balanced";
          //   let bc = "g";
          //   let sub = `${e.completed || 0} tasks — healthy WIP level`;

          //   if (workload > 10) {
          //     status = "Overload";
          //     bg = "#FEE2E2";
          //     ico = "#EF4444";
          //     badge = "Overload";
          //     bc = "r";
          //     sub = "Consider redistributing workload";
          //   } else if (workload > 5) {
          //     status = "Monitor";
          //     bg = "#FEF3C7";
          //     ico = "#F59E0B";
          //     badge = "Monitor";
          //     bc = "y";
          //     sub = "Monitor for blockers daily";
          //   }

          //   return {
          //     bg,
          //     ico,
          //     nm: `${e.name} ${status === "Overload" ? "overloaded" : status === "Monitor" ? "has moderate workload" : "has balanced workload"} with ${workload} tasks`,
          //     sub,
          //     badge,
          //     bc
          //   };
          // })
        }
      },
      {
        id: 3,
        gradient: KPIGradient3,
        label: "Approved by Me",
        value: totals.totalApproved.toString(),
        // chg: "↑ 18",
        chgUp: true,
        type: "spark",
        sparkHeights: [55, 70, 40, 90, 75, 100, 80],
        chips: [`This Week (${approvedbymeData?.Approved})`, `Pending (${approvedbymeData?.Pending})`, `Blocked (${approvedbymeData?.Block})`],
        icon: <path fillRule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" />,
        pop: {
          sub: "Tasks approved by manager this cycle",
          stats: [{ v: approvedbymeData?.SelfApproved, l: "Self" }, { v: approvedbymeData?.ManagerApproved, l: "Manager" }, { v: approvedbymeData?.ManagerTransferred, l: "Transferred" }],
          chartLabel: "Daily Completion This Week",
          bkLabel: "Completion by Member",
          //  breakdown: employees.map(e => ({
          //   dot: e.color || "#3B82F6",
          //   lbl: e.name,
          //   v: e.week.cp ? e.week.cp.reduce((sum, val) => sum + val, 0) : 0,
          //   max: Math.max(...employees.map(x => x.week.cp?.reduce((s, v) => s + v, 0) || 0), 100),
          //   badge: "Tasks Completed",
          //   bc: "b"
          // })),
          // breakdown: [
          //   { dot: "#10B981", lbl: "Feature Tasks", v: Math.round(totals.totalApproved * 0.66), max: totals.totalApproved, badge: "66%", bc: "g" },
          //   { dot: "#3B82F6", lbl: "Bug Fixes", v: Math.round(totals.totalApproved * 0.21), max: totals.totalApproved, badge: "21%", bc: "b" },
          //   { dot: "#F59E0B", lbl: "Improvements", v: Math.round(totals.totalApproved * 0.09), max: totals.totalApproved, badge: "9%", bc: "y" },
          //   { dot: "#EF4444", lbl: "Rejected", v: Math.round(totals.totalApproved * 0.04), max: totals.totalApproved, badge: "4%", bc: "r" }
          // ],
          breakdown: employees.map((e, index) => {
            const weeklyCompleted = e.week.cp
              ? e.week.cp.reduce((sum, val) => sum + val, 0)
              : 0;
            const weeklyInProgress = e.week.ip
              ? e.week.ip.reduce((sum, val) => sum + val, 0)
              : 0;

            const weeklyBacklog = e.week.bk
              ? e.week.bk.reduce((sum, val) => sum + val, 0)
              : 0;

            // total tasks THIS WEEK
            const weeklyTotal = weeklyCompleted + weeklyInProgress + weeklyBacklog;

            // const weeklyAssigned = e.week.as
            //   ? e.week.as.reduce((sum, val) => sum + val, 0)
            //   : 0;

            // const weeklyTotal = e.week.total || 0; // MUST exist

            const percentage = weeklyTotal
              ? Math.round((weeklyCompleted / weeklyTotal) * 100)
              : 0;

            const maxValue = Math.max(
              ...employees.map(x =>
                x.week.cp?.reduce((s, v) => s + v, 0) || 0
              ),
              100
            );

            return {
              dot: fallbackColors[index % fallbackColors.length],
              lbl: e.name,
              v: weeklyCompleted,
              max: maxValue,
              badge: `${percentage}%`, // ✅ THIS WEEK %
              bc: "b"
            };
          }),
          actions: (() => {
            const pending = Number(approvedbymeData?.Pending || 0);
            const blocked = Number(approvedbymeData?.Block || 0);
            const approved = Number(approvedbymeData?.Approved || 0);

            const actions = [];

            // 🟡 Pending Approval
            if (pending > 0) {
              actions.push({
                bg: "#FEF3C7",
                ico: "#F59E0B",
                nm: `${pending} tasks pending your approval`,
                sub: pending > 10 ? "High backlog — review soon" : "Keep approvals flowing",
                badge: "Pending",
                bc: "y"
              });
            }

            // 🔴 Blockers
            if (blocked > 0) {
              actions.push({
                bg: "#FEE2E2",
                ico: "#EF4444",
                nm: `${blocked} blocked tasks need attention`,
                sub: "Resolve blockers to avoid delays",
                badge: "Blocked",
                bc: "r"
              });
            }

            // 📉 Trend-based action (from chart)
            if (isDropping) {
              actions.push({
                bg: "#FEF3C7",
                ico: "#F59E0B",
                nm: "Completion trend dropping this week",
                sub: `Avg daily: ${avgDailyCompletion} tasks`,
                badge: "Trend ↓",
                bc: "y"
              });
            }

            // 🟢 Good performance
            if (approved > 0) {
              const approvalRate = pending + approved
                ? Math.round((approved / (approved + pending)) * 100)
                : 0;

              actions.push({
                bg: "#D1FAE5",
                ico: "#10B981",
                nm: `${approved} tasks approved`,
                sub: `Approval rate: ${approvalRate}%`,
                badge: approvalRate > 80 ? "On Track" : "Review Needed",
                bc: "g"
              });
            }

            return actions;
          })()
          // actions: [
          //   { bg: "#FEF3C7", ico: "#F59E0B", nm: "8 tasks pending your approval", sub: "Oldest pending: 2 days ago", badge: "Pending", bc: "y" },
          //   { bg: "#FEE2E2", ico: "#EF4444", nm: "6 tasks blocked — needs resolution", sub: "Blocking team progress", badge: "Blocker", bc: "r" },
          //   { bg: "#D1FAE5", ico: "#10B981", nm: `${totals.totalApproved} approved — team on track`, sub: "Approval rate: 96% this cycle", badge: "On Track", bc: "g" }
          // ]
        }
      },
      {
        id: 4, 
        gradient: KPIGradient4,
        label: "Pending Approvals", value: approvedbymeData?.Pending,
        // chg: "↓ 4", 
        chgUp: false,
        type: "progress", progLbl: "Action needed", progVal: "High · Med", progPct: 37,
        chips: [`Overdue (${approvedbymeData?.OverDue})`, `Today (${approvedbymeData?.OnTime})`, `Upcoming (${approvedbymeData?.Upcoming})`],
        icon: <path d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z" />,
        pop: {
          sub: "Tasks awaiting manager approval", stats: [{ v: totals.totalApproved.toString(), l: "Approved" }, { v: approvedbymeData?.Pending, l: "Pending" }, { v: approvedbymeData?.Block, l: "Blocked" }],
          chartLabel: "Weekly Approval Trend",
          bkLabel: "Approval Breakdown",
          breakdown: (() => {
            const approved = approvedbymeData?.Approved || 0
            const pending = approvedbymeData?.Pending || 0
            const blocked = approvedbymeData?.Block || 0

            const maxValue = Math.max(approved, pending, blocked, 10);

            return [
              {
                dot: approvedColor,
                lbl: "Approved",
                v: approved,
                max: maxValue,
                badge: `${approved} tasks`,
                bc: "g"
              },
              {
                dot: toDoColor,
                lbl: "Pending",
                v: pending,
                max: maxValue,
                badge: `${pending} tasks`,
                bc: "y"
              },
              {
                dot: blockedColor,
                lbl: "Blocked",
                v: blocked,
                max: maxValue,
                badge: `${blocked} tasks`,
                bc: "r"
              }
            ];
          })(),
          actions: (() => {

            const approved = approvedbymeData?.Approved || 0;
            const pending = approvedbymeData?.Pending || 0;
            const blocked = approvedbymeData?.Block || 0;

            // weekly trend
            const dailyApproved = employees[0]?.week?.ap?.map((_, i) =>
              employees.reduce((sum, e) => sum + (e.week.ap?.[i] || 0), 0)
            ) || [];

            const isIncreasing =
              dailyApproved.length >= 2 &&
              dailyApproved[dailyApproved.length - 1] >
              dailyApproved[dailyApproved.length - 2];

            const actions = [];

            // 🔴 Overdue / High Pending
            if (pending > 50) {
              actions.push({
                bg: "#FEE2E2",
                ico: "#EF4444",
                nm: `${pending} approvals pending`,
                sub: "High backlog — may delay delivery",
                badge: "Overdue",
                bc: "r"
              });
            }

            // 🟡 Moderate Pending
            else if (pending > 10) {
              actions.push({
                bg: "#FEF3C7",
                ico: "#F59E0B",
                nm: `${pending} approvals waiting`,
                sub: "Review regularly to avoid pile-up",
                badge: "Pending",
                bc: "y"
              });
            }

            // 🔴 Blockers
            if (blocked > 0) {
              actions.push({
                bg: "#FEE2E2",
                ico: "#EF4444",
                nm: `${blocked} blocked tasks`,
                sub: "Needs immediate resolution",
                badge: "Blocker",
                bc: "r"
              });
            }

            // 📈 Trend insight
            if (isIncreasing) {
              actions.push({
                bg: "#D1FAE5",
                ico: "#10B981",
                nm: "Approval trend improving",
                sub: "More approvals processed recently",
                badge: "Trend ↑",
                bc: "g"
              });
            }

            // 🟢 Performance summary
            if (approved > 0) {
              const rate = pending + approved
                ? Math.round((approved / (approved + pending)) * 100)
                : 0;

              actions.push({
                bg: "#D1FAE5",
                ico: "#10B981",
                nm: `${approved} approvals completed`,
                sub: `Approval rate: ${rate}%`,
                badge: rate > 80 ? "On Track" : "Needs Focus",
                bc: "g"
              });
            }

            return actions;
          })()
          // breakdown: [{ dot: "#2563EB", lbl: "Approved", v: 3, max: 8, badge: "3 tasks", bc: "b" }, { dot: "#EF4444", lbl: "Pending", v: 3, max: 8, badge: "2 tasks", bc: "y" }, { dot: "#065F46", lbl: "Blocked", v: 2, max: 8, badge: "2 tasks", bc: "y" }],
          // actions: [{ bg: "#FEE2E2", ico: "#EF4444", nm: "3 approvals overdue (2+ days)", sub: "Deliverables may be delayed", badge: "Overdue", bc: "r" }, { bg: "#FEF3C7", ico: "#F59E0B", nm: "2 approvals due today", sub: "Review before 5:00 PM", badge: "Due Today", bc: "y" }, { bg: "#D1FAE5", ico: "#10B981", nm: "3 upcoming tasks ready for review", sub: "Assigned by team this morning", badge: "Upcoming", bc: "g" }]
        },
      }
    ];
  };

  const KPI_CARDS = generateKPICards();

  const theme = {
    bg: dark ? "#0F1520" : "#F4F6FA",
    card: dark ? "#182033" : "#fff",
    card2: dark ? "#1E2B40" : "#F8F9FC",
    txt: dark ? "#E2E8F0" : "#1A1F2E",
    txt2: dark ? "#94A3B8" : "#6B7280",
    txt3: dark ? "#475569" : "#9CA3AF",
    border: dark ? "rgba(255,255,255,.07)" : "rgba(0,0,0,.07)",
    border2: dark ? "rgba(255,255,255,.13)" : "rgba(0,0,0,.13)",
    sidebar: dark ? "#0D1625" : "#1E2A3B",
    topbar: dark ? "#182033" : "#fff",
    // accent: "#00B9AE",
    accent: completedColor,
  };

  useEffect(() => {
    dispatch(dashBoard_V2({ data: { EmployeeID: empID, Type: params.Type, CompanyID: compID } }));
  }, [dispatch, empID, params]);

  // Prepare team performance data
  const perfData = empFilter === "all"
    ? (teamPerformanceData?.all || [])
    : (teamPerformanceData?.all || []).filter((_, idx) => idx === parseInt(empFilter));

  // Prepare workload data
  const workloadData = workloadDataFromAPI.length > 0 ? workloadDataFromAPI : [];

  // Prepare priority data
  // const priorityData = priorityDataFromAPI.length > 0 ? priorityDataFromAPI : {};
  const priorityData = priorityDataFromAPI?.week
    ? {
      week: priorityDataFromAPI.week.map((d) => ({
        ...d,
        value: Number(d.value)
      })),
      month: priorityDataFromAPI.month.map((d) => ({
        ...d,
        value: Number(d.value)
      }))
    }
    : { week: [], month: [] };
  // const priorityData = {
  //   "week": [
  //     {
  //       "name": "High",
  //       "value": 120,
  //       "color": "#EF4444"
  //     },
  //     {
  //       "name": "Medium",
  //       "value": 180,
  //       "color": "#F59E0B"
  //     },
  //     {
  //       "name": "Low",
  //       "value": 90,
  //       "color": "#10B981"
  //     }
  //   ],
  //   "month": [
  //     {
  //       "name": "High",
  //       "value": 250,
  //       "color": "#EF4444"
  //     },
  //     {
  //       "name": "Medium",
  //       "value": 189,
  //       "color": "#F59E0B"
  //     },
  //     {
  //       "name": "Low",
  //       "value": 250,
  //       "color": "#10B981"
  //     }
  //   ]
  // }
  const pctColor = p => p >= 85 ? "#10B981" : p >= 75 ? "#3B82F6" : p >= 65 ? "#F59E0B" : "#EF4444";

  // const METRIC_KEYS = {
  //   all: [
  //     { k: "Tasks", c: "#3B82F6" },
  //     { k: "Approved", c: "#10B981" },
  //     { k: "Completed", c: "#22C55E" },
  //     { k: "Transferred", c: "#8B5CF6" },
  //     { k: "InProgress", c: "#F59E0B" },
  //     { k: "Backlog", c: "#EF4444" }
  //   ],
  //   tasks: [
  //     { k: "Tasks", c: "#3B82F6" },
  //     { k: "InProgress", c: "#F59E0B" },
  //     { k: "Backlog", c: "#EF4444" }
  //   ],
  //   approval: [
  //     { k: "Approved", c: "#10B981" },
  //     { k: "Completed", c: "#22C55E" },
  //     { k: "Transferred", c: "#8B5CF6" }
  //   ]
  // };

  const METRIC_KEYS = {
    all: [
      { k: "Tasks", c: totalTaskColor },
      { k: "Approved", c: approvedColor },
      { k: "Completed", c: completedColor },
      { k: "Transferred", c: transferredColor },
      { k: "InProgress", c: toDoColor },
      { k: "Backlog", c: backLogColor },
      { k: "Blocked", c: blockedColor },
      { k: "Rejected", c: rejectedColor }
    ],
    tasks: [
      { k: "Tasks", c: totalTaskColor },
      { k: "InProgress", c: toDoColor },
      { k: "Backlog", c: backLogColor }
    ],
    approval: [
      { k: "Approved", c: approvedColor },
      { k: "Completed", c: completedColor },
      { k: "Transferred", c: transferredColor }
    ]
  };

  const metricKeys = METRIC_KEYS[metric] || METRIC_KEYS.all;

    if (loadingV2) return (
        <Box sx={{ p: 3 }}>
          <Grid container spacing={2}>
            {[1, 2, 3, 4].map(i => (
              <Grid item xs={12} sm={6} md={3} key={i}>
                <Skeleton variant="rounded" height={120} />
              </Grid>
            ))}
  
            <Grid item xs={12} md={6}>
              <Skeleton variant="rounded" height={300} />
            </Grid>
  
            <Grid item xs={12} md={6}>
              <Skeleton variant="rounded" height={300} />
            </Grid>
  
            <Grid item xs={12} md={4}>
              <Skeleton variant="rounded" height={350} />
            </Grid>
  
            <Grid item xs={12} md={4}>
              <Skeleton variant="rounded" height={350} />
            </Grid>
  
            <Grid item xs={12} md={4}>
              <Skeleton variant="rounded" height={350} />
            </Grid>
          </Grid>
  
        </Box>
    );

  return (
    <div style={{ fontFamily: "'Outfit',sans-serif", background: theme.bg, color: theme.txt, minHeight: "100vh", transition: "background .2s, color .2s" }}>
      {/* <link href="https://fonts.googleapis.com/css2?family=Nunito:wght@400;500;600;700;800&family=JetBrains+Mono:wght@500;600&display=swap" rel="stylesheet" /> */}
      <link href="https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&display=swap" rel="stylesheet" />

      {/* ── TOPBAR ── */}
      {/* <header
        style={{
          position: "fixed",
          top: 0,
          right: 0,
          left: collapsed ? 60 : 250,   
          height: 58,
          transition: "left .2s ease",  
          background: theme.topbar,
          borderBottom: `1px solid ${theme.border}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 20px",
          zIndex: 50,
        }}
      > */}
      <div style={{
        transition: "left .2s ease",
        background: theme.topbar, borderBottom: '1px solid rgba(0,0,0,0.07)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 28px', height: 58, position: 'sticky', top: 0, zIndex: 50
      }}>

        {/* LEFT SIDE */}
        <div
          style={{
            // fontSize: "20px",
            fontSize: "clamp(12px, 2vw, 20px)",
            fontWeight: 800,
            color: theme.txt,
            fontWeight: "bold",
          }}
        >
          {/* {isCalendar ? "TASK CALENDAR" : "MANAGER DASHBOARD"} */}
          {getGreeting()}, {EmpName}
        </div>

        {/* RIGHT SIDE */}
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>

          <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, fontWeight: 600, color: theme.txt2, background: theme.card2, border: `1px solid ${theme.border}`, borderRadius: 7, padding: "5px 12px" }}>
            <svg viewBox="0 0 20 20" fill={theme.txt3} width={13} height={13}><path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" /></svg>
            {new Date().toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' })}
          </div>
          {/* Theme */}
          {/* <button onClick={() => setDark(d => !d)} style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, fontWeight: 600, color: theme.txt2, background: theme.card2, border: `1px solid ${theme.border}`, borderRadius: 7, padding: "5px 12px", cursor: "pointer" }}>
            <svg viewBox="0 0 20 20" fill={theme.txt2} width={14} height={14}>
              {dark ? <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z" /> : <path d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z" />}
            </svg>
            <div style={{ width: 8, height: 8, borderRadius: "50%", background: theme.accent }} />
            <span>{dark ? "Dark" : "Light"}</span>
          </button> */}

          {/* Employee Dashboard Button */}
          <button
            onClick={() => {
              dispatch(
                dashBoardAtten({ data: { EmployeeID: empID, Type: "E" } })
              );
              navigate("/Apps/dashbord/E");
            }}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 32,
              height: 32,
              borderRadius: 10,
              border: '1px solid rgba(0,0,0,0.07)',
              color: '#55c4d0',
              cursor: 'pointer',
              transition: 'all .18s'
            }}
            title="Show Employee Dashboard"
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#f1f5f9';
            }}
          >
            <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <circle cx="9" cy="7" r="3" />
              <path d="M12 13c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z" />
              <path d="M3 20c0-2.209 2.239-4 5-4s5 1.791 5 4" />
              <path d="M16 20c0-2.209 1.119-4 2.5-4S21 17.791 21 20" />
            </svg>
          </button>

          {/* Calendar Toggle Button */}
          <button
            onClick={() => setIsCalendar(!isCalendar)}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 32,
              height: 32,
              borderRadius: 10,
              border: `1px solid ${isCalendar ? theme.accent : theme.border}`,
              // background: isCalendar ? theme.accent : theme.card2,
              color: '#55c4d0',
              cursor: 'pointer',
              transition: 'all .18s'
            }}
            title={isCalendar ? "Show Manager Dashboard" : "Show Calendar"}
          >
            <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <rect x="3" y="4" width="18" height="18" rx="2" />
              <line x1="16" y1="2" x2="16" y2="6" />
              <line x1="8" y1="2" x2="8" y2="6" />
              <line x1="3" y1="10" x2="21" y2="10" />
              <path d="M9 14h6M9 18h6" />
            </svg>
          </button>

          {/* Avatar */}
          {/* <div style={{ width: 34, height: 34, borderRadius: "50%", background: theme.accent, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, fontWeight: 700, color: "#fff", cursor: "pointer" }}>RM</div> */}
          <div style={{ width: 32, height: 32, borderRadius: '50%', background: theme.accent, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 700, color: '#fff', cursor: 'pointer', textAlign: 'center', overflow: 'hidden', whiteSpace: 'nowrap' }} title={EmpName}>
            {EmpName?.split(' ').slice(0, 2).map(word => word[0]?.toUpperCase()).join('')}
          </div>
        </div>
      </div>

      {/* ── MAIN CONTENT ── */}
      <main style={{ marginTop: 10, padding: 10, minHeight: "calc(100vh - 58px)", transition: "margin-left .2s ease" }}>

        {/* Dashboard Content */}
        {!isCalendar && (
          <React.Fragment>
            {/* KPI Cards */}
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 16, marginBottom: 20 }}>
              {KPI_CARDS.map(card => <KpiCard key={card.id} card={card} onClick={setKpiPopup} />)}
            </div>

            {/* Team Performance Chart */}
            <div style={{ background: theme.card, borderRadius: 16, border: `1px solid ${theme.border}`, padding: 18, boxShadow: "0 1px 8px rgba(0,0,0,.07)", marginBottom: 16 }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 14 }}>
                <span style={{ fontSize: 13, fontWeight: 800, color: theme.txt, letterSpacing: ".07em" }}>Team Performance Overview</span>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  {/* Member filter */}
                  <div style={{ display: "flex", gap: 4 }}>
                    <button
                      onClick={() => setEmpFilter("all")}
                      style={{
                        fontSize: 10, fontWeight: 700, padding: "4px 11px", borderRadius: 20,
                        border: `1px solid ${empFilter === "all" ? theme.accent : theme.border2}`,
                        color: empFilter === "all" ? "#fff" : theme.txt2,
                        background: empFilter === "all" ? theme.accent : theme.card2,
                        cursor: "pointer", transition: "all .15s"
                      }}
                    >
                      All
                    </button>
                    {employees.slice(0, 30).map((e, idx) => (
                      <button
                        key={e.name}
                        title={e.name}
                        onClick={() => setEmpFilter(idx.toString())}
                        style={{
                          fontSize: 10, fontWeight: 700, padding: "4px 11px", borderRadius: 20,
                          border: `1px solid ${empFilter === idx.toString() ? theme.accent : theme.border2}`,
                          color: empFilter === idx.toString() ? "#fff" : (e.color || theme.txt2),
                          background: empFilter === idx.toString() ? theme.accent : theme.card2,
                          cursor: "pointer", transition: "all .15s"
                        }}

                      >
                        {e.name?.split(' ').slice(0, 2).map(word => word[0]?.toUpperCase()).join('')}
                      </button>
                    ))}
                  </div>
                  {/* Metric toggle */}
                  {/* <div style={{ display: "flex", gap: 4, background: theme.card2, padding: 3, borderRadius: 7, border: `1px solid ${theme.border}` }}>
                    {[{ k: "all", l: "All" }, { k: "tasks", l: "Tasks" }, { k: "approval", l: "Approval" }].map(m => (
                      <button key={m.k} onClick={() => setMetric(m.k)}
                        style={{ fontSize: 11, fontWeight: 700, padding: "4px 12px", borderRadius: 5, border: "none", cursor: "pointer", background: metric === m.k ? theme.accent : "transparent", color: metric === m.k ? "#fff" : theme.txt2, transition: "all .2s" }}>
                        {m.l}
                      </button>
                    ))}
                  </div> */}
                </div>
              </div>
              {/* Summary strip */}
              <div style={{ 
                display: "grid",
                //  gridTemplateColumns: "repeat(6,1fr)",
                 gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))", 
                 gap: 8, marginBottom: 14 
                 }}>
                {[
                  // { v: totals.totalTasks.toLocaleString(), l: "Total Tasks", c: totalTaskColor },
                  // { v: totals.totalApproved.toLocaleString(), l: "Approved", c: approvedColor },
                  // { v: totals.totalCompleted.toLocaleString(), l: "Completed", c: completedColor },
                  // { v: totals.totalTransferred.toString(), l: "Transferred", c: transferredColor },
                  // { v: totals.totalInProgress.toString(), l: "InProgress", c: toDoColor },
                  // { v: totals.totalBacklog.toString(), l: "Backlog", c: backLogColor },
                  { v: totals.totalTasks, l: "Total Tasks", c: totalTaskColor },
                  { v: totals.totalApproved, l: "Approved", c: approvedColor },
                  { v: totals.totalCompleted, l: "Completed", c: completedColor },
                  { v: totals.totalTransferred, l: "Transferred", c: transferredColor },
                  { v: totals.totalInProgress, l: "InProgress", c: toDoColor },
                  { v: totals.totalBacklog, l: "Backlog", c: backLogColor },
                  { v: totals.totalRejected, l: "Rejected", c: rejectedColor },
                  { v: totals.totalBlocked, l: "Blocked", c: blockedColor }
                ].map(s => (
                  <div key={s.l} style={{ background: theme.card2, border: `1px solid ${theme.border}`, borderRadius: 8, padding: "9px 10px", textAlign: "center" }}>
                    <div style={{ fontSize: 18, fontWeight: 800, color: s.c, fontFamily: "'Outfit',sans-serif" }}>{s.v}</div>
                    <div style={{ fontSize: 9, color: theme.txt3, fontWeight: 700, marginTop: 2 }}>{s.l}</div>
                  </div>
                ))}
              </div>
              {perfData.length > 0 && (
                <div style={{ height: 240 }}>
                  <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={perfData}
                      margin={{
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: -20
                      }}
                    // onClick={d => { if (d?.activePayload) { const empData = employees.find(e => perfData.find(p => p.name?.includes(e.name))); if (empData) setEmpModal(empData); } }}
                    >
                      <XAxis dataKey="name" tick={{ fontSize: 12, fill: "#113fd4" }} axisLine={false} tickLine={false} />
                      <YAxis tick={{ fontSize: 11, fill: "#9CA3AF" }} axisLine={false} tickLine={false} />
                      <CartesianGrid strokeDasharray="3 3" stroke="rgba(128,128,128,.08)" vertical={false} />
                      <Tooltip content={<CUSTOM_TOOLTIP />} />
                      {metricKeys.map(m =>
                        <Bar
                          key={m.k}
                          dataKey={m.k}
                          fill={m.c}
                          radius={[5, 5, 0, 0]}
                          onClick={(data) => {
                            const clickedName = data.payload.name;

                            const employee = employees.find(
                              (e) => e.name === clickedName
                            );

                            console.log("FULL EMPLOYEE 👉", employee);

                            setSelectedEmployee(employee);
                            setOpenDrilldown(true);
                          }}

                        />)}
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              )}
              <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginTop: 12, alignItems: "center" }}>
                {metricKeys.map(m => (
                  <div key={m.k} style={{ display: "flex", alignItems: "center", gap: 5, fontSize: 10, fontWeight: 600, color: theme.txt2 }}>
                    <div style={{ width: 9, height: 9, borderRadius: 2, background: m.c }} />{m.k}
                  </div>
                ))}
                <div style={{ marginLeft: "auto", fontSize: 10, color: theme.txt3, fontWeight: 600 }}>Click bar to drill down</div>
              </div>
            </div>

            {/* Row 2: Priority + Workload */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 16 }}>
              {/* Priority */}
              <div
                style={{
                  background: theme.card,
                  borderRadius: 16,
                  border: `1px solid ${theme.border}`,
                  padding: 18,
                  boxShadow: "0 1px 8px rgba(0,0,0,.07)"
                }}
              >
                {/* HEADER */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: 14
                  }}
                >
                  <span
                    style={{
                      fontSize: 13,
                      fontWeight: 800,
                      color: theme.txt,
                      letterSpacing: ".07em"
                    }}
                  >
                    Priority Distribution
                  </span>

                  {/* TOGGLE BUTTONS */}
                  <div style={{ display: "flex", gap: 6 }}>
                    <div
                      onClick={() => setViewType("week")}
                      style={{
                        padding: "4px 10px",
                        borderRadius: 6,
                        fontSize: 10,
                        fontWeight: 700,
                        cursor: "pointer",
                        background: viewType === "week" ? toDoColor : theme.card2,
                        color: viewType === "week" ? "#fff" : theme.txt2
                      }}
                    >
                      W2D
                    </div>

                    <div
                      onClick={() => setViewType("month")}
                      style={{
                        padding: "4px 10px",
                        borderRadius: 6,
                        fontSize: 10,
                        fontWeight: 700,
                        cursor: "pointer",
                        background: viewType === "month" ? toDoColor : theme.card2,
                        color: viewType === "month" ? "#fff" : theme.txt2
                      }}
                    >
                      M2D
                    </div>
                  </div>
                </div>

                {/* SUB TITLE */}
                <div
                  style={{
                    fontSize: 11,
                    color: "#fff",
                    fontWeight: 600,
                    marginBottom: 10
                  }}
                >
                  {viewType === "week" ? "This Week" : "This Month"}
                </div>

                {/* DATA */}
                {(() => {
                  const chartData = priorityData?.[viewType] || [];

                  return (
                    chartData.length > 0 && (
                      <>
                        {/* CHART + LIST */}
                        <div style={{ display: "flex", alignItems: "center", gap: 18 }}>
                          {/* PIE */}
                          <div
                            style={{
                              position: "relative",
                              width: 130,
                              height: 130,
                              flexShrink: 0
                            }}
                          >
                            <ResponsiveContainer width="100%" height="100%">
                              <PieChart>
                                <Pie
                                  data={chartData}
                                  cx="50%"
                                  cy="50%"
                                  innerRadius={42}
                                  outerRadius={62}
                                  dataKey="value"
                                  paddingAngle={2}
                                >
                                  {chartData.map((d) => (
                                    <Cell key={d.name} fill={d.color} />
                                  ))}
                                </Pie>
                              </PieChart>
                            </ResponsiveContainer>

                            {/* CENTER TOTAL */}
                            <div
                              style={{
                                position: "absolute",
                                inset: 0,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                pointerEvents: "none"
                              }}
                            >
                              <div
                                style={{
                                  fontSize: 20,
                                  fontWeight: 800,
                                  color: theme.txt,
                                  fontFamily: "'Outfit',sans-serif"
                                }}
                              >
                                {chartData.reduce(
                                  (sum, d) => sum + Number(d.value || 0),
                                  0
                                )}
                              </div>
                              <div
                                style={{
                                  fontSize: 10,
                                  fontWeight: 700,
                                  color: theme.txt3
                                }}
                              >
                                Total
                              </div>
                            </div>
                          </div>

                          {/* RIGHT LIST */}
                          <div
                            style={{
                              flex: 1,
                              display: "flex",
                              flexDirection: "column",
                              gap: 10
                            }}
                          >
                            {chartData.map((r) => {
                              const total = chartData.reduce(
                                (sum, d) => sum + Number(d.value || 0),
                                0
                              );
                              const pct = total
                                ? Math.round((r.value / total) * 100)
                                : 0;

                              return (
                                <div
                                  key={r.name}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 8
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 5,
                                      width: 72
                                    }}
                                  >
                                    <span
                                      style={{
                                        width: 8,
                                        height: 8,
                                        borderRadius: "50%",
                                        background: r.color,
                                        flexShrink: 0,
                                        display: "inline-block"
                                      }}
                                    />
                                    <span
                                      style={{
                                        fontSize: 11,
                                        color: theme.txt2,
                                        fontWeight: 600
                                      }}
                                    >
                                      {r.name}
                                    </span>
                                  </div>

                                  <div
                                    style={{
                                      flex: 1,
                                      height: 6,
                                      background: theme.card2,
                                      borderRadius: 3,
                                      overflow: "hidden",
                                      border: `1px solid ${theme.border}`
                                    }}
                                  >
                                    <div
                                      style={{
                                        height: "100%",
                                        width: `${pct}%`,
                                        background: r.color,
                                        borderRadius: 3
                                      }}
                                    />
                                  </div>

                                  <div
                                    style={{
                                      fontSize: 10,
                                      fontWeight: 700,
                                      color: theme.txt,
                                      width: 34,
                                      textAlign: "right",
                                      fontFamily: "'Outfit',sans-serif"
                                    }}
                                  >
                                    {r.value}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>

                        {/* BOTTOM CARDS */}
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(3,1fr)",
                            gap: 8,
                            marginTop: 14
                          }}
                        >
                          {chartData.map((p) => {
                            const total = chartData.reduce(
                              (sum, d) => sum + Number(d.value || 0),
                              0
                            );
                            const pct = total
                              ? Math.round((p.value / total) * 100)
                              : 0;

                            return (
                              <div
                                key={p.name}
                                style={{
                                  background: theme.card2,
                                  border: `1px solid ${theme.border}`,
                                  borderRadius: 8,
                                  padding: 9,
                                  textAlign: "center"
                                }}
                              >
                                <div
                                  style={{
                                    fontSize: 16,
                                    fontWeight: 800,
                                    color: p.color,
                                    fontFamily: "'Outfit',sans-serif"
                                  }}
                                >
                                  {pct}%
                                </div>
                                <div
                                  style={{
                                    fontSize: 9,
                                    color: theme.txt3,
                                    fontWeight: 700,
                                    marginTop: 2
                                  }}
                                >
                                  {p.name} Priority
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </>
                    )
                  );
                })()}
              </div>
              {/* <div style={{ background: theme.card, borderRadius: 16, border: `1px solid ${theme.border}`, padding: 18, boxShadow: "0 1px 8px rgba(0,0,0,.07)" }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 14 }}>
                  <span style={{ fontSize: 12, fontWeight: 800, color: theme.txt, letterSpacing: ".07em" }}>Priority Distribution</span>
                  <span style={{ fontSize: 11, color: theme.txt3, fontWeight: 600 }}>All Tasks</span>
                </div>
                {priorityData.length > 0 && (
                  <div style={{ display: "flex", alignItems: "center", gap: 18 }}>
                    <div style={{ position: "relative", width: 130, height: 130, flexShrink: 0 }}>
                      <ResponsiveContainer width="100%" height="100%">
                        <PieChart>
                          <Pie data={priorityData} cx="50%" cy="50%" innerRadius={42} outerRadius={62} dataKey="value" paddingAngle={2}>
                            {priorityData.map(d => <Cell key={d.name} fill={d.color} />)}
                          </Pie>
                        </PieChart>
                      </ResponsiveContainer>
                      <div style={{ position: "absolute", inset: 0, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", pointerEvents: "none" }}>
                        <div style={{ fontSize: 20, fontWeight: 800, color: theme.txt, fontFamily: "monospace" }}>
                          {priorityData.reduce((sum, d) => sum + (d.value || 0), 0)}
                        </div>
                        <div style={{ fontSize: 10, fontWeight: 700, color: theme.txt3 }}>Total</div>
                      </div>
                    </div>
                    <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 10 }}>
                      {priorityData.map((r, idx) => {
                        const total = priorityData.reduce((sum, d) => sum + (d.value || 0), 0);
                        const pct = Math.round((r.value / total) * 100);
                        return (
                          <div key={r.name} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <div style={{ display: "flex", alignItems: "center", gap: 5, width: 72 }}>
                              <span style={{ width: 8, height: 8, borderRadius: "50%", background: r.color, flexShrink: 0, display: "inline-block" }} />
                              <span style={{ fontSize: 11, color: theme.txt2, fontWeight: 600 }}>{r.name}</span>
                            </div>
                            <div style={{ flex: 1, height: 6, background: theme.card2, borderRadius: 3, overflow: "hidden", border: `1px solid ${theme.border}` }}>
                              <div style={{ height: "100%", width: `${pct}%`, background: r.color, borderRadius: 3 }} />
                            </div>
                            <div style={{ fontSize: 10, fontWeight: 700, color: theme.txt, width: 34, textAlign: "right", fontFamily: "monospace" }}>{r.value}</div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
                <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 8, marginTop: 14 }}>
                  {priorityData.map(p => {
                    const total = priorityData.reduce((sum, d) => sum + (d.value || 0), 0);
                    const pct = Math.round((p.value / total) * 100);
                    return (
                      <div key={p.name} style={{ background: theme.card2, border: `1px solid ${theme.border}`, borderRadius: 8, padding: 9, textAlign: "center" }}>
                        <div style={{ fontSize: 16, fontWeight: 800, color: p.color, fontFamily: "monospace" }}>{pct}%</div>
                        <div style={{ fontSize: 9, color: theme.txt3, fontWeight: 700, marginTop: 2 }}>{p.name} Priority</div>
                      </div>
                    );
                  })}
                </div>
              </div> */}

              {/* Workload */}
              <div style={{ background: theme.card, borderRadius: 16, border: `1px solid ${theme.border}`, padding: 18, boxShadow: "0 1px 8px rgba(0,0,0,.07)" }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 14 }}>
                  <span style={{ fontSize: 13, fontWeight: 800, color: theme.txt, letterSpacing: ".07em" }}>Team Workload Distribution</span>
                  <span style={{ fontSize: 11, color: theme.txt3, fontWeight: 600 }}>Current Period</span>
                </div>
                {workloadData.length > 0 && (
                  <div style={{ height: 200 }}>
                    <ResponsiveContainer width="100%" height="100%">
                      <BarChart data={workloadData} layout="vertical" margin={{ top: 0, right: 0, bottom: 0, left: 10 }}>
                        <XAxis type="number" tick={{ fontSize: 10, fill: "#9CA3AF" }} axisLine={false} tickLine={false} />
                        <YAxis type="category" dataKey="name" tick={{ fontSize: 11, fill: "#9CA3AF" }} axisLine={false} tickLine={false} width={80} />
                        <Tooltip content={<CUSTOM_TOOLTIP />} />
                        <Bar dataKey="Backlog" stackId="a" fill={backLogColor} />
                        <Bar dataKey="InProgress" stackId="a" fill={toDoColor} />
                        <Bar dataKey="Completed" stackId="a" fill={completedColor} />
                        <Bar dataKey="Approved" stackId="a" fill={approvedColor} />
                        <Bar dataKey="Blocked" stackId="a" fill={blockedColor} radius={[0, 5, 5, 0]} />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                )}
                <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginTop: 10 }}>
                  {[{ c: backLogColor, l: "Backlog" }, { c: toDoColor, l: "InProgress" }, { c: completedColor, l: "Completed" }, { c: approvedColor, l: "Approved" }, { c: blockedColor, l: "Blocked" }].map(l => (
                    <div key={l.l} style={{ display: "flex", alignItems: "center", gap: 5, fontSize: 10, fontWeight: 600, color: theme.txt2 }}>
                      <div style={{ width: 9, height: 9, borderRadius: 2, background: l.c }} />{l.l}
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Row 3: Team Completion + Leave Tracker */}
            <div style={{ display: "grid", gridTemplateColumns: "4fr 8fr", gap: 16 }}>
              {/* Team Completion Rate */}
              <div style={{ background: theme.card, borderRadius: 16, border: `1px solid ${theme.border}`, padding: 18, boxShadow: "0 1px 8px rgba(0,0,0,.07)" }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: theme.txt, letterSpacing: ".05em", marginBottom: 14 }}>Team Completion Rate</div>
                {/* <div style={{ display: "flex", flexDirection: "column", gap: 14 }}> */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 14,
                    maxHeight: 300,
                    overflowY: "auto",
                    overflowX: "hidden",
                    paddingRight: 4
                  }}
                >
                  {employees.map((e, index) => {
                    const avatarColor = fallbackColors[index % fallbackColors.length];

                    return (
                      <div key={e.id || index} style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        <div
                          style={{
                            width: 34,
                            height: 34,
                            borderRadius: "50%",
                            background: avatarColor, // ✅ FIXED
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: 11,
                            fontWeight: 700,
                            color: "#fff",
                            flexShrink: 0
                          }}
                        >
                          {e.name
                            ?.split(" ")
                            .slice(0, 2)
                            .map(word => word[0]?.toUpperCase())
                            .join("")}
                        </div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", overflowY: "auto", overflowX: "auto", marginBottom: 4 }}>
                            <span style={{ fontSize: 12, fontWeight: 700, color: theme.txt }}>{e.name}</span>
                            <span style={{ fontSize: 12, fontWeight: 800, color: avatarColor, fontFamily: "'Outfit',sans-serif" }}>{e.pct || 0}%</span>
                          </div>
                          <div style={{ height: 7, background: theme.card2, borderRadius: 4, overflow: "hidden", border: `1px solid ${theme.border}` }}>
                            <div style={{ height: "100%", width: `${e.pct || 0}%`, background: avatarColor, borderRadius: 4 }} />
                          </div>
                          <div style={{ display: "flex", gap: 10, marginTop: 4 }}>
                            {[
                              { c: completedColor, l: `Completed: ${e.completed || 0}` },
                              { c: toDoColor, l: `In Progress: ${e.inprogress || 0}` },
                              { c: backLogColor, l: `Backlog: ${e.backlog || 0}` }
                            ].map(d => (
                              <div key={d.l} style={{ fontSize: 9, color: theme.txt3, fontWeight: 700, display: "flex", alignItems: "center", gap: 3 }}>
                                <div style={{ width: 5, height: 5, borderRadius: "50%", background: d.c }} />{d.l}
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>

              </div>

              {/* Leave Tracker */}
              <div
                style={{
                  background: theme.card,
                  borderRadius: 16,
                  border: `1px solid ${theme.border}`,
                  padding: 18,
                  boxShadow: "0 1px 8px rgba(0,0,0,.07)",
                  height: 400, // ✅ FIX HEIGHT
                  display: "flex",
                  flexDirection: "column"
                }}
              >
                {/* HEADER */}
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 14 }}>
                  <span style={{ fontSize: 13, fontWeight: 800, color: theme.txt, letterSpacing: ".07em" }}>
                    Leave Tracker
                  </span>
                  <span style={{ fontSize: 11, color: theme.txt3, fontWeight: 600 }}>
                    List of Employees
                  </span>
                </div>

                {/* TABLE SCROLL AREA */}
                {leaveData.length > 0 ? (
                  <div style={{ flex: 1, overflowY: "auto", overflowX: "auto" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <thead>
                        <tr>
                          {["#", "Employee", "Leave Type", "From", "To", "Approved By", "Days", "Status"].map(h => (
                            <th key={h} style={{
                              fontSize: 10, fontWeight: 800, color: theme.txt3, letterSpacing: ".07em", padding: "8px 10px", textAlign: "left", borderBottom: `1px solid ${theme.border}`, whiteSpace: "nowrap",
                              position: "sticky",
                              top: 0,
                              background: theme.card,   // important to avoid transparency
                              zIndex: 2
                            }}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {leaveData.map((row, idx) => (
                          <tr key={idx} style={{
                            borderBottom: `1px solid ${theme.border}`,
                            cursor: row.status === "AL" ? "pointer" : "default"
                          }}
                            onMouseEnter={e => { e.currentTarget.style.background = theme.card2; }}
                            onMouseLeave={e => { e.currentTarget.style.background = ""; }}
                            onClick={() => {
                              if (row.status === "AL") {
                                setSelectedRow(row);   // store clicked row
                                setOpenModal(true);    // open modal
                              }
                            }}
                          >
                            <td style={{ padding: "14px 10px", fontSize: 12, fontWeight: 600, color: theme.txt3, verticalAlign: "middle" }}>{idx + 1}</td>
                            <td style={{ padding: "14px 10px", verticalAlign: "middle" }}>
                              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                <div style={{ width: 34, height: 34, borderRadius: "50%", background: row.color || "#3B82F6", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 800, color: "#fff", flexShrink: 0 }}>{row.name?.split(" ").slice(0, 2).map(word => word[0]?.toUpperCase())}</div>
                                <div style={{ fontSize: 12, fontWeight: 700, color: theme.txt }}>{row.name}</div>
                              </div>
                            </td>
                            <td style={{ padding: "14px 10px", verticalAlign: "middle" }}>
                              <span style={{ fontSize: 10, fontWeight: 700, padding: "4px 10px", borderRadius: 20, background: "#EFF6FF", color: "#1D4ED8" }}>
                                {row.type || "Leave"}
                              </span>
                            </td>
                            <td style={{ padding: "14px 10px", fontSize: 11, color: theme.txt2, verticalAlign: "middle" }}>{row.from || "—"}</td>
                            <td style={{ padding: "14px 10px", fontSize: 11, color: theme.txt2, verticalAlign: "middle" }}>{row.to || "—"}</td>
                            <td style={{ padding: "14px 10px", verticalAlign: "middle" }}>
                              <span style={{ fontSize: 11, fontWeight: 700, color: theme.accent }}>{row.approvedBy || "—"}</span>
                            </td>
                            <td style={{ padding: "14px 10px", fontSize: 13, fontWeight: 800, fontFamily: "'Outfit',sans-serif", color: theme.txt, verticalAlign: "middle", textAlign: "right" }}>{row.days || "0"}</td>
                            <td style={{ padding: "14px 10px", verticalAlign: "middle" }}>
                              <span style={{ fontSize: 10, fontWeight: 700, padding: "3px 10px", borderRadius: 20, background: row.status === "Approved" ? "#F0FDF4" : "#FFFBEB", color: row.status === "Approved" ? "#166534" : "#92400E" }}>
                                {/* {row.status || "Pending"} */}
                                {row.status == "AL" ? "Applied" :
                                  row.status == "AP" ? "Approved" :
                                    row.status == "RJ" ? "Rejected" :
                                      row.status == "QR" ? "Query" :
                                        row.status == "RA" ? "Re-Applied" : 
                                        row.status == "PA" ? "Partially Approved" : ""
                                }
                              </span>
                            </td>
                          </tr>
                        ))}

                      </tbody>
                    </table>

                  </div>
                ) : (
                  <div style={{ padding: "20px", textAlign: "center", color: theme.txt3 }}>
                    No leave data available
                  </div>
                )}
                <LeaveApprovalModal
                  open={openModal}
                  onClose={() => setOpenModal(false)}
                  rowData={selectedRow}
                  ManagerID={empID}
                  parameters={params.Type}
                />
              </div>
              {/* <div style={{ background: theme.card, borderRadius: 16, border: `1px solid ${theme.border}`, padding: 18, boxShadow: "0 1px 8px rgba(0,0,0,.07)" }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 14 }}>
                  <span style={{ fontSize: 12, fontWeight: 800, color: theme.txt, letterSpacing: ".07em" }}>Leave Tracker</span>
                  <span style={{ fontSize: 11, color: theme.txt3, fontWeight: 600 }}>List of Employees</span>
                </div>
                {leaveData.length > 0 ? (
                  <div style={{ overflowX: "auto" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <thead>
                        <tr>
                          {["#", "Employee", "Leave Type", "From", "To", "Approved By", "Days", "Status"].map(h => (
                            <th key={h} style={{ fontSize: 10, fontWeight: 800, color: theme.txt3, letterSpacing: ".07em", padding: "8px 10px", textAlign: "left", borderBottom: `1px solid ${theme.border}`, whiteSpace: "nowrap" }}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {leaveData.map((row, idx) => (
                          <tr key={idx} style={{ borderBottom: `1px solid ${theme.border}` }}
                            onMouseEnter={e => { e.currentTarget.style.background = theme.card2; }}
                            onMouseLeave={e => { e.currentTarget.style.background = ""; }}>
                            <td style={{ padding: "14px 10px", fontSize: 12, fontWeight: 600, color: theme.txt3, verticalAlign: "middle" }}>{idx + 1}</td>
                            <td style={{ padding: "14px 10px", verticalAlign: "middle" }}>
                              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                <div style={{ width: 34, height: 34, borderRadius: "50%", background: row.color || "#3B82F6", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 800, color: "#fff", flexShrink: 0 }}>{row.name?.split(" ").slice(0, 2).map(word => word[0]?.toUpperCase())}</div>
                                <div style={{ fontSize: 12, fontWeight: 700, color: theme.txt }}>{row.name}</div>
                              </div>
                            </td>
                            <td style={{ padding: "14px 10px", verticalAlign: "middle" }}>
                              <span style={{ fontSize: 10, fontWeight: 700, padding: "4px 10px", borderRadius: 20, background: "#EFF6FF", color: "#1D4ED8" }}>
                                {row.type || "Leave"}
                              </span>
                            </td>
                            <td style={{ padding: "14px 10px", fontSize: 11, color: theme.txt2, verticalAlign: "middle" }}>{row.from || "—"}</td>
                            <td style={{ padding: "14px 10px", fontSize: 11, color: theme.txt2, verticalAlign: "middle" }}>{row.to || "—"}</td>
                            <td style={{ padding: "14px 10px", verticalAlign: "middle" }}>
                              <span style={{ fontSize: 11, fontWeight: 700, color: theme.accent }}>{row.approvedBy || "—"}</span>
                            </td>
                            <td style={{ padding: "14px 10px", fontSize: 13, fontWeight: 800, fontFamily: "monospace", color: theme.txt, verticalAlign: "middle", textAlign: "right" }}>{row.days || "0"}</td>
                            <td style={{ padding: "14px 10px", verticalAlign: "middle" }}>
                              <span style={{ fontSize: 10, fontWeight: 700, padding: "3px 10px", borderRadius: 20, background: row.status === "Approved" ? "#F0FDF4" : "#FFFBEB", color: row.status === "Approved" ? "#166534" : "#92400E" }}>
                                {row.status || "Pending"}
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div style={{ padding: "20px", textAlign: "center", color: theme.txt3 }}>No leave data available</div>
                )}
              </div> */}
            </div>
          </React.Fragment>
        )}

        {/* Calendar View */}
        {isCalendar && (
          <Paper
            elevation={2}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              mt: 2,
              p: 2,
            }}
          >
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              width="100%"
              px={2}
              mb={1}
            >
              {/* Legends */}
              <Box display="flex" alignItems="center" gap={2}>
                <Box display="flex" alignItems="center" gap={0.5}>
                  <Box
                    sx={{
                      width: 14,
                      height: 14,
                      backgroundColor: "#b9ecee",
                      borderRadius: "3px",
                    }}
                  />
                  <span style={{ fontSize: "13px" }}>Holiday</span>
                </Box>

                <Box display="flex" alignItems="center" gap={0.5}>
                  <Box
                    sx={{
                      width: 14,
                      height: 14,
                      backgroundColor: "#f3bac296",
                      borderRadius: "3px",
                    }}
                  />
                  <span style={{ fontSize: "13px" }}>WeekOff</span>
                </Box>

                <Box display="flex" alignItems="center" gap={0.5}>
                  <Box
                    sx={{
                      width: 14,
                      height: 14,
                      backgroundColor: "#ddcab1",
                      borderRadius: "3px",
                    }}
                  />
                  <span style={{ fontSize: "13px" }}>Leave</span>
                </Box>
              </Box>

              {/* Employee Autocomplete - Only for Managers */}
              {isManager === "1" && (
                <Employeeautocomplete
                  sx={{ width: 250 }}
                  name="empName"
                  label="Personnel"
                  id="empName"
                  value={selectedEmp}
                  onChange={(newValue) => {
                    if (newValue) {
                      setSelectedEmp(newValue);
                      const selectedEmpID = newValue.RecordID;
                      dispatch(
                        DashcalpostData({
                          Year: "2026",
                          Month: "01,02,03,04,05,06,07,08,09,10,11,12",
                          EmployeeID: selectedEmpID,
                        })
                      );
                    } else {
                       setSelectedEmp(null);
                      dispatch(
                        DashcalpostData({
                          Year: "2026",
                          Month: "01,02,03,04,05,06,07,08,09,10,11,12",
                          EmployeeID: empID,
                        })
                      );
                    }
                  }}
                  url={`${listViewurl}?data={"Query":{"AccessID":"2101","ScreenName":"EMPLOYEETEAMS","Filter":"parentID=${empID}","Any":"","CompId":${compID}}}`}
                />
              )}
            </Box>
            {/* Calendar Component */}
            <Datavisual1 />
          </Paper>
        )}
      </main>

      {/* KPI Popup */}
      {kpiPopup && <KpiPopup card={kpiPopup} employees={employees} onClose={() => setKpiPopup(null)} colors={overallColors}/>}

      {/* Employee Modal */}
      {empModal && <EmpModal emp={empModal} onClose={() => setEmpModal(null)} />}
      {drillModal && <DrillDownModal drill={drillModal} tasks={drillTasks} onClose={() => setDrillModal(null)} />}
      <DrilldownDialog
        open={openDrilldown}
        employee={selectedEmployee}
        onClose={() => setOpenDrilldown(false)}
        colors={overallColors}
      />
    </div>
  );
}

